/**
 * Returns a list of all participles used for the Portuguese passive voice assessment.
 * For each participle, versions for all four possible suffixes (-o, -a, -os, -as) are included.
 * @returns {Array} The list with participles.
 */
export default function() {
	return [
		"encontrado",
		"levado",
		"considdo",
		"condenado",
		"registrado",
		"encaminhado",
		"realizado",
		"lançado",
		"aprovado",
		"acusado",
		"divulgado",
		"apresentado",
		"usado",
		"dado",
		"localizado",
		"identido",
		"publicado",
		"votado",
		"anuncdo",
		"abordado",
		"libdo",
		"baleado",
		"mcado",
		"ado",
		"assassinado",
		"informado",
		"prepado",
		"utilizado",
		"resultado",
		"assinado",
		"revelado",
		"confirmado",
		"chamado",
		"acionado",
		"notido",
		"formado",
		"passado",
		"contratado",
		"autuado",
		"invigado",
		"nomeado",
		"retirado",
		"chegado",
		"convidado",
		"quionado",
		"colocado",
		"apontado",
		"acabado",
		"flagrado",
		"limitado",
		"denuncdo",
		"julgado",
		"innado",
		"envdo",
		"deixado",
		"constatado",
		"pticipado",
		"complicado",
		"obrigado",
		"relacionado",
		"derrotado",
		"inaugurado",
		"espdo",
		"dinado",
		"afastado",
		"cuidado",
		"aplicado",
		"ligado",
		"tratado",
		"eliminado",
		"baseado",
		"convocado",
		"matado",
		"grdo",
		"registado",
		"entrado",
		"fechado",
		"dgnosticado",
		"indicado",
		"analisado",
		"preocupado",
		"addo",
		"começado",
		"prorrogado",
		"agendado",
		"capturado",
		"negado",
		"acompanhado",
		"indicdo",
		"aumentado",
		"executado",
		"resgatado",
		"enrado",
		"casado",
		"inaproprdo",
		"recomendado",
		"citado",
		"procurado",
		"alcançado",
		"declado",
		"organizado",
		"roubado",
		"elaborado",
		"mado",
		"instaurado",
		"trabalhado",
		"transportado",
		"errado",
		"voltado",
		"inicdo",
		"achado",
		"gdo",
		"logado",
		"cancelado",
		"mostrado",
		"atacado",
		"minado",
		"comprado",
		"solicitado",
		"emprado",
		"conquistado",
		"inessado",
		"alado",
		"tentado",
		"derrubado",
		"do",
		"encerrado",
		"acostumado",
		"montado",
		"fundado",
		"demasdo",
		"autorizado",
		"advogado",
		"disputado",
		"atropelado",
		"assocdo",
		"recupdo",
		"filmado",
		"ajudado",
		"abandonado",
		"crdo",
		"causado",
		"jogado",
		"rejeitado",
		"alvejado",
		"falado",
		"apaixonado",
		"multado",
		"firmado",
		"inrogado",
		"premdo",
		"libertado",
		"noticdo",
		"homenageado",
		"deminado",
		"pensado",
		"comemorado",
		"negocdo",
		"comunicado",
		"dedicado",
		"demonstrado",
		"criticado",
		"instalado",
		"obvado",
		"esfaqueado",
		"culpado",
		"inspirado",
		"sepultado",
		"pado",
		"adotado",
		"controlado",
		"acendido",
		"notado",
		"opdo",
		"acessado",
		"assaltado",
		"projetado",
		"mudado",
		"apanhado",
		"disponibilizado",
		"engraçado",
		"inditado",
		"calculado",
		"programado",
		"consultado",
		"cobrado",
		"celebrado",
		"responsabilizado",
		"respeitado",
		"detectado",
		"cortado",
		"eleito deputado",
		"falhado",
		"implementado",
		"selecionado",
		"motivado",
		"afetado",
		"verido",
		"sentado",
		"forçado",
		"acordado",
		"batizado",
		"reforçado",
		"exondo",
		"atuado",
		"imado",
		"provocado",
		"espancado",
		"fotografado",
		"tado",
		"baixado",
		"aceitado",
		"licencdo",
		"deputado",
		"enfrentado",
		"quivado",
		"implantado",
		"ldo",
		"dispensado",
		"supdo",
		"protocolado",
		"evitado",
		"ultrapassado",
		"repassado",
		"apagado",
		"recusado",
		"desenhado",
		"anulado",
		"provado",
		"avisado",
		"perguntado",
		"nformado",
		"relatado",
		"explicado",
		"afirmado",
		"apurado",
		"encado",
		"focado",
		"comerclizado",
		"modido",
		"explorado",
		"inpretado",
		"lembrado",
		"classido",
		"empenhado",
		"reado",
		"incenddo",
		"escalado",
		"vicdo",
		"afogado",
		"aprecdo",
		"equipado",
		"empatado",
		"inceptado",
		"praticado",
		"designado",
		"aproveitado",
		"orientado",
		"sequrado",
		"direcionado",
		"velado",
		"tirado",
		"buscado",
		"transformado",
		"habituado",
		"violado",
		"adequado",
		"prejudicado",
		"oficlizado",
		"confrontado",
		"beneficdo",
		"dominado",
		"isolado",
		"ampldo",
		"detetado",
		"apostado",
		"processado",
		"comprovado",
		"compado",
		"situado",
		"atualizado",
		"ganhado",
		"vedado",
		"cansado",
		"coordenado",
		"idealizado",
		"conectado",
		"tornado",
		"rastado",
		"ameaçado",
		"finalizado",
		"ocupado",
		"renovado",
		"reivindicado",
		"elevado",
		"desempregado",
		"planejado",
		"cercado",
		"nçado",
		"vetado",
		"integrado",
		"remessado",
		"melhorado",
		"efetuado",
		"hospitalizado",
		"financdo",
		"republicado",
		"mencionado",
		"bloqueado",
		"atirado",
		"apodo",
		"concentrado",
		"atrasado",
		"acertado",
		"abusado",
		"poupado",
		"doado",
		"editado",
		"embrgado",
		"lavrado",
		"entrevistado",
		"comandado",
		"gostado",
		"ordenado",
		"em ado",
		"vinculado",
		"lotado",
		"em chegado",
		"udado",
		"elogdo",
		"cruzado",
		"desvdo",
		"sentencdo",
		"fixado",
		"cacizado",
		"andado",
		"em passado",
		"representado",
		"administrado",
		"desctado",
		"furtado",
		"puxado",
		"agudado",
		"intimado",
		"adaptado",
		"funcionado",
		"visitado",
		"conplado",
		"lesionado",
		"conversado",
		"fildo",
		"hospedado",
		"avistado",
		"assegurado",
		"alimentado",
		"trocado",
		"empossado",
		"facultado",
		"vado",
		"configurado",
		"ministrado",
		"evacuado",
		"quebrado",
		"cassado",
		"cotado",
		"homologado",
		"enquadrado",
		"dacado",
		"revado",
		"mandado",
		"graduado",
		"penalizado",
		"monitorado",
		"rebaixado",
		"copdo",
		"ferdo",
		"justido",
		"impulsionado",
		"concretizado",
		"decretado",
		"agracdo",
		"viu obrigado",
		"m chegado",
		"torturado",
		"levantado",
		"recapturado",
		"trdo",
		"extraditado",
		"m pticipado",
		"apelidado",
		"antecipado",
		"captado",
		"postado",
		"noticiado",
		"prestado",
		"impressionado",
		"compartilhado",
		"contado",
		"optado",
		"fabricado",
		"dasiado",
		"medicado",
		"ampliado",
		"estado",
		"estimado",
		"questionado",
		"confessado",
		"estuprado",
		"prevado",
		"calado",
		"criado",
		"queimado",
		"descartado",
		"encarado",
		"á levado",
		"estudado",
		"alertado",
		"tomado",
		"carregado",
		"barrado",
		"patado",
		"associado",
		"preparado",
		"marcado",
		"sancionado",
		"esgotado",
		"influenciado",
		"irritado",
		"ovacionado",
		"iniciado",
		"contactado",
		"estreado",
		"apoiado",
		"partilhado",
		"bêbado",
		"alargado",
		"arriscado",
		"participado",
		"cadastrado",
		"gravado",
		"disparado",
		"ignorado",
		"faltado",
		"implentado",
		"colaborado",
		"encomendado",
		"depositado",
		"danido",
		"normalizado",
		"enganado",
		"donstrado",
		"diagnosticado",
		"avançado",
		"denunciado",
		"enviado",
		"valorizado",
		"beneficiado",
		"condecorado",
		"aliado",
		"negociado",
		"deslocado",
		"parcelado",
		"desativado",
		"comercializado",
		"tivesse do",
		"completado",
		"incorporado",
		"pressionado",
		"comorado",
		"desligado",
		"desviado",
		"especializado",
		"treinado",
		"virado",
		"briagado",
		"orçado",
		"reavaliado",
		"delicado",
		"despertado",
		"pesado",
		"financiado",
		"despregado",
		"sorteado",
		"sequestrado",
		"possado",
		"condicionado",
		"chumbado",
		"ativado",
		"tenham do",
		"armado",
		"alinhado",
		"encontrado carbonizado",
		"acatado",
		"delegado",
		"presenciado",
		"sondado",
		"viajado",
		"pecado",
		"tenham passado",
		"solucionado",
		"crado",
		"dificultado",
		"apropriado",
		"tivesse passado",
		"adiado",
		"regressado",
		"assinalado",
		"inocentado",
		"compensado",
		"tocado",
		"deitado",
		"amado",
		"reformado",
		"amarrado",
		"goleado",
		"arratado",
		"castigado",
		"animado",
		"destinado",
		"m dado",
		"indagado",
		"entregado",
		"rodado",
		"lutado",
		"inventado",
		"combinado",
		"investigado",
		"purrado",
		"efetivado",
		"liddo",
		"avaliado",
		"aconselhado",
		"ateado",
		"retratado",
		"protagonizado",
		"arranjado",
		"parado",
		"á marcado",
		"iam do",
		"continuado",
		"replicado",
		"arbitrado",
		"reportado",
		"equilibrado",
		"apreciado",
		"decretar estado",
		"tombado",
		"preditado",
		"manifestado",
		"m deixado",
		"imobilizado",
		"destacado",
		"contestado",
		"declarado",
		"pagado",
		"dorado",
		"suscitado",
		"moddo",
		"revogado",
		"guardado",
		"adicionado",
		"estipulado",
		"ajustado",
		"intensido",
		"desafiado",
		"examinado",
		"comparado",
		"galardoado",
		"adiantado",
		"arrombado",
		"reajustado",
		"á fechado",
		"á deixado",
		"vê obrigado",
		"privado",
		"sagrado",
		"mercado",
		"arquivado",
		"importado",
		"formalizado",
		"priado",
		"vazado",
		"atravessado",
		"suportado",
		"pregado",
		"testado",
		"diferenciado",
		"separado",
		"comentado",
		"reprovado",
		"circulado",
		"armazenado",
		"alcoolizado",
		"clicado",
		"matriculado",
		"arrastado",
		"patrocinado",
		"atrelado",
		"chocado",
		"aposentado",
		"pintado",
		"filiado",
		"os obvado",
		"despenhado",
		"tivesse chegado",
		"sacado",
		"recepcionado",
		"recado",
		"incetado",
		"m entrado",
		"anunciado",
		"cogitado",
		"agradado",
		"contabilizado",
		"paralisado",
		"cursado",
		"escapado",
		"recompensado",
		"aclamado",
		"chateado",
		"á entrado",
		"acreditado",
		"recuado",
		"encantado",
		"indiciado",
		"regulamentado",
		"facilitado",
		"revisado",
		"arrancado",
		"dotado",
		"anexado",
		"arrecadado",
		"recheado",
		"retornado",
		"desarmado",
		"encontrados",
		"publicados",
		"registrados",
		"mediados",
		"levados",
		"utilizados",
		"encaminhados",
		"denunciados",
		"bloqueados",
		"identificados",
		"divulgados",
		"votados",
		"considerados",
		"usados",
		"realizados",
		"apresentados",
		"condenados",
		"vetados",
		"acionados",
		"tratados",
		"retirados",
		"localizados",
		"alados",
		"acusados",
		"obrigados",
		"liberados",
		"chamados",
		"criados",
		"esperados",
		"confirmados",
		"colocados",
		"abordados",
		"notificados",
		"autuados",
		"aprovados",
		"informados",
		"convidados",
		"enviados",
		"revelados",
		"marcados",
		"preocupados",
		"selecionados",
		"recuperados",
		"resgatados",
		"registados",
		"assassinados",
		"flagrados",
		"invigados",
		"lançados",
		"preparados",
		"convocados",
		"contratados",
		"afetados",
		"dinados",
		"cancelados",
		"relacionados",
		"baleados",
		"roubados",
		"transportados",
		"o invigados",
		"prados",
		"disponibilizados",
		"anunciados",
		"instalados",
		"comprados",
		"mobilizados",
		"dados",
		"ligados",
		"indiciados",
		"contabilizados",
		"julgados",
		"fechados",
		"avaliados",
		"ar preparados",
		"analisados",
		"afastados",
		"consultados",
		"executados",
		"capturados",
		"assinados",
		"repassados",
		"apontados",
		"aplicados",
		"atacados",
		"eliminados",
		"o realizados",
		"beneficiados",
		"parados",
		"inessados",
		"armados",
		"disparados",
		"habituados",
		"concentrados",
		"evitados",
		"doados",
		"acostumados",
		"coletados",
		"armazenados",
		"citados",
		"achados",
		"incendiados",
		"orientados",
		"nomeados",
		"libertados",
		"associados",
		"armazenar dados",
		"descartados",
		"avisados",
		"autorizados",
		"innados",
		"responsabilizados",
		"furtados",
		"focados",
		"acompanhados",
		"indicados",
		"detectados",
		"deixados",
		"formados",
		"contplados",
		"multados",
		"queimados",
		"espalhados",
		"arrecadados",
		"priados",
		"derrotados",
		"obvados",
		"somos obrigados",
		"deslocados",
		"efetuados",
		"resultados",
		"respeitados",
		"fiscalizados",
		"acessados",
		"programados",
		"iniciados",
		"detetados",
		"tomados",
		"ob resultados",
		"esgotados",
		"desviados",
		"danificados",
		"dispensados",
		"limitados",
		"classificados",
		"solicitados",
		"abandonados",
		"recapturados",
		"levantados",
		"casados",
		"apanhados",
		"comercializados",
		"baseados",
		"alcançados",
		"instaurados",
		"o procurados",
		"iam usados",
		"procurados",
		"homenageados",
		"diagnosticados",
		"separados",
		"trocados",
		"prejudicados",
		"enrados",
		"vinculados",
		"o utilizados",
		"leiloados",
		"cobrados",
		"entrevistados",
		"declarados",
		"fomos informados",
		"disputados",
		"penhados",
		"praticados",
		"fabricados",
		"mandados",
		"rejeitados",
		"incentivados",
		"cortados",
		"gerados",
		"dacados",
		"aproveitados",
		"apresentar resultados",
		"ocupados",
		"relatados",
		"agendados",
		"deletados",
		"tados",
		"representados",
		"treinados",
		"forçados",
		"adotados",
		"constatados",
		"causados",
		"cumpre mandados",
		"alertados",
		"fotografados",
		"atrasados",
		"comunicados",
		"assaltados",
		"vacinados",
		"apaixonados",
		"inditados",
		"considere inadequados",
		"depositados",
		"quionados",
		"negociados",
		"ofertados",
		"cansados",
		"ar fechados",
		"apurados",
		"evacuados",
		"elaborados",
		"matriculados",
		"voltados",
		"encerrados",
		"negados",
		"sorteados",
		"sequrados",
		"gravados",
		"montados",
		"cumprir mandados",
		"reportados",
		"integrados",
		"ob dados",
		"processados",
		"lotados",
		"importados",
		"entusiasmados",
		"errados",
		"o analisados",
		"despregados",
		"exonerados",
		"fornecer dados",
		"arrastados",
		"firmados",
		"inceptados",
		"retomados",
		"moderados",
		"arquivados",
		"equipados",
		"organizados",
		"ameaçados",
		"prar cuidados",
		"visualizados",
		"recolher dados",
		"controlados",
		"patados",
		"jogados",
		"adicionados",
		"monitorados",
		"poupados",
		"vistoriados",
		"verificados",
		"celebrados",
		"elevados",
		"administrados",
		"iam utilizados",
		"produzir resultados",
		"possados",
		"visitados",
		"direcionados",
		"quebrados",
		"aliados",
		"variados",
		"hospitalizados",
		"apresenta resultados",
		"alinhados",
		"roubar dados",
		"aguardados",
		"incorporados",
		"implantados",
		"cadastrados",
		"lesionados",
		"revoltados",
		"filmados",
		"mostrados",
		"ar acompanhados",
		"hospedados",
		"conquistados",
		"avançados",
		"ficaram assustados",
		"considerados culpados",
		"apresentou resultados",
		"exist dados",
		"culpados",
		"editados",
		"ar ligados",
		"penalizados",
		"recomendados",
		"atualizados",
		"desligados",
		"imputados",
		"transformados",
		"conectados",
		"teve resultados",
		"lbrados",
		"o encaminhados",
		"inrogados",
		"arressados",
		"atropelados",
		"revados",
		"sentados",
		"adiados",
		"escalados",
		"inspira cuidados",
		"inaugurados",
		"financiados",
		"apreciados",
		"o colocados",
		"projetados",
		"passados",
		"cuidados",
		"compensados",
		"intimados",
		"enquadrados",
		"derrubados",
		"explorados",
		"designados",
		"melhorados",
		"calculados",
		"implentados",
		"tirados",
		"barrados",
		"assustados",
		"alvejados",
		"superados",
		"runerados",
		"adequados",
		"enganados",
		"chocados",
		"afogados",
		"alimentados",
		"ministrados",
		"cumpriram mandados",
		"ultrapassados",
		"renovados",
		"alcançar resultados",
		"pensados",
		"desafiados",
		"assegurados",
		"prevados",
		"guardados",
		"paralisados",
		"habilitados",
		"agraciados",
		"acampados",
		"ar focados",
		"o apurados",
		"reforçados",
		"apresentaram resultados",
		"baixados",
		"o obrigados",
		"o prejudicados",
		"provocados",
		"cassados",
		"capacitados",
		"imulados",
		"apoiados",
		"desesperados",
		"o avaliados",
		"dedicados",
		"pertences roubados",
		"desenhados",
		"ficaram espalhados",
		"inpretados",
		"ficaram impressionados",
		"pregados",
		"protocolados",
		"torturados",
		"indignados",
		"trabalhados",
		"suportados",
		"analisou dados",
		"avistados",
		"recepcionados",
		"reúne dados",
		"animados",
		"divulgou dados",
		"recrutados",
		"parcelados",
		"indexados",
		"lavrados",
		"ficaram danificados",
		"o executados",
		"somos confrontados",
		"anotados",
		"ranejados",
		"efugiados",
		"listados",
		"ignorados",
		"computados",
		"for considerados",
		"adaptados",
		"captados",
		"movimentados",
		"indicam dados",
		"retratados",
		"solucionados",
		"contactados",
		"confrontados",
		"cercados",
		"sepultados",
		"plantados",
		"mencionados",
		"reivindicados",
		"comparados",
		"udados",
		"imados",
		"imunizados",
		"mostram dados",
		"refugiados",
		"confiscados",
		"arratados",
		"pesquisados",
		"infectados",
		"compartilhados",
		"situados",
		"arrancados",
		"anulados",
		"encarados",
		"apresentadados",
		"motivados",
		"exportados",
		"alocados",
		"finalizados",
		"inspirados",
		"violados",
		"operados",
		"incetados",
		"criticados",
		"realizada",
		"encontrada",
		"criada",
		"considerada",
		"tomada",
		"limitada",
		"aprovada",
		"divulgada",
		"nada",
		"marcada",
		"levada",
		"confirmada",
		"acionada",
		"publicada",
		"registrada",
		"apresentada",
		"anunciada",
		"encaminhada",
		"usada",
		"lançada",
		"deu entrada",
		"chamada",
		"mada",
		"pagar nada",
		"inmada",
		"identida",
		"aplicada",
		"utilizada",
		"decada",
		"relacionada",
		"condenada",
		"adiada",
		"encerrada",
		"inaugurada",
		"liberada",
		"revelada",
		"abordada",
		"localizada",
		"estão cada",
		"colocada",
		"são cada",
		"agendada",
		"fundada",
		"enviada",
		"retirada",
		"cada",
		"iniciada",
		"baseada",
		"acusada",
		"notida",
		"assassinada",
		"avançada",
		"convidada",
		"vetada",
		"dar entrada",
		"vedada",
		"ligada",
		"dada",
		"disputada",
		"autorizada",
		"internada",
		"deflagrada",
		"baleada",
		"contratada",
		"preparada",
		"votada",
		"assinada",
		"acompanhada",
		"tratada",
		"tinha nada",
		"convocada",
		"obrigada",
		"fechada",
		"determinada",
		"cancelada",
		"analisada",
		"diagnosticada",
		"casada",
		"adotada",
		"procurada",
		"comunicada",
		"partilhada",
		"motivada",
		"atacada",
		"flagrada",
		"destinada",
		"montada",
		"solicitada",
		"associada",
		"apontada",
		"faz nada",
		"organizada",
		"entrada",
		"nomeada",
		"decretada",
		"interditada",
		"deram entrada",
		"eliminada",
		"questionada",
		"rejeitada",
		"preocupada",
		"instalada",
		"programada",
		"gravada",
		"alterada",
		"criticada",
		"tirada",
		"constatada",
		"esperada",
		"visitada",
		"investigada",
		"comprada",
		"voltada",
		"deixada",
		"resgatada",
		"assaltada",
		"declarada",
		"derrotada",
		"reçada",
		"liderada",
		"batizada",
		"atropelada",
		"afetada",
		"roubada",
		"indicada",
		"parada",
		"descartada",
		"respeitada",
		"causada",
		"recuperada",
		"estuprada",
		"sancionada",
		"autuada",
		"transportada",
		"avaliada",
		"julgada",
		"controlada",
		"inspirada",
		"dizer nada",
		"afastada",
		"fotografada",
		"havnada",
		"retomada",
		"denunciada",
		"executada",
		"pensada",
		"dedicada",
		"ameaçada",
		"abandonada",
		"contada",
		"citada",
		"provocada",
		"filmada",
		"cobrada",
		"cortada",
		"levantada",
		"antecipada",
		"concentrada",
		"implementada",
		"repassada",
		"efetuada",
		"consultada",
		"elaborada",
		"falar nada",
		"acessada",
		"focada",
		"empenhada",
		"encarada",
		"achada",
		"detectada",
		"negada",
		"complicada",
		"situada",
		"avisada",
		"sentada",
		"projetada",
		"orientada",
		"multada",
		"passada",
		"comentada",
		"desencadeada",
		"ajuizada",
		"justida",
		"alimentada",
		"premiada",
		"apreciada",
		"feito nada",
		"compartilhada",
		"celebrada",
		"disponibilizada",
		"aconteceu nada",
		"interpretada",
		"isolada",
		"recomendada",
		"caracterizada",
		"errada",
		"derrubada",
		"registada",
		"disse nada",
		"obvada",
		"transmada",
		"protocolada",
		"interessada",
		"esfaqueada",
		"selecionada",
		"sequestrada",
		"estudada",
		"alcançada",
		"integrada",
		"çada",
		"condicionada",
		"fixada",
		"evitada",
		"ampliada",
		"oficializada",
		"classida",
		"explicada",
		"ocupada",
		"editada",
		"finalizada",
		"implantada",
		"apaixonada",
		"detetada",
		"revogada",
		"comandada",
		"coordenada",
		"enterrada",
		"custa nada",
		"superada",
		"responsabilizada",
		"bloqueada",
		"especializada",
		"alertada",
		"homenageada",
		"conquistada",
		"acertada",
		"fazem nada",
		"desenhada",
		"negociada",
		"verida",
		"elevada",
		"testada",
		"jogada",
		"apoiada",
		"representada",
		"orçada",
		"arrastada",
		"recusada",
		"explorada",
		"concretizada",
		"capturada",
		"acostumada",
		"comprovada",
		"sabe nada",
		"estimada",
		"furtada",
		"libertada",
		"calculada",
		"promulgada",
		"trabalhada",
		"elogiada",
		"direcionada",
		"planejada",
		"assegurada",
		"clicada",
		"postada",
		"abusada",
		"comparada",
		"renovada",
		"arremessada",
		"arrombada",
		"alvejada",
		"administrada",
		"anulada",
		"prejudicada",
		"violada",
		"adequada",
		"operada",
		"advogada",
		"prestada",
		"espancada",
		"puxada",
		"tornada",
		"aproveitada",
		"ministrada",
		"indiciada",
		"alinhada",
		"acordada",
		"comemorada",
		"comercializada",
		"noticiada",
		"vinculada",
		"quebrada",
		"evacuada",
		"conplada",
		"adaptada",
		"chumbada",
		"contestada",
		"dominada",
		"danida",
		"beneficiada",
		"atrasada",
		"licenciada",
		"chegada",
		"hospedada",
		"prorrogada",
		"idealizada",
		"atualizada",
		"apanhada",
		"destacada",
		"aguardada",
		"revada",
		"mostrada",
		"viu nada",
		"cercada",
		"melhorada",
		"prevada",
		"privilegiada",
		"sediada",
		"instaurada",
		"regulamentada",
		"gerada",
		"barrada",
		"ultrapassada",
		"relatada",
		"intimada",
		"hospitalizada",
		"malizada",
		"aumentada",
		"arquivada",
		"normalizada",
		"desativada",
		"lembrada",
		"financiada",
		"influenciada",
		"sabnada",
		"encomendada",
		"cansada",
		"desempregada",
		"praticada",
		"doada",
		"deslocada",
		"trocada",
		"paralisada",
		"homologada",
		"captada",
		"apagada",
		"lotada",
		"designada",
		"adjudicada",
		"modida",
		"acatada",
		"medicada",
		"ver nada",
		"processada",
		"violentada",
		"ignorada",
		"incendiada",
		"acontecer nada",
		"fazer piada",
		"tornar cada",
		"alargada",
		"estamos cada",
		"r parada",
		"equipada",
		"estacionada",
		"incorporada",
		"ganhar nada",
		"afogada",
		"escalada",
		"empatada",
		"mudada",
		"remada",
		"habituada",
		"encabeçada",
		"delicada",
		"contactada",
		"coroada",
		"impulsionada",
		"sei nada",
		"deitada",
		"veiculada",
		"mencionada",
		"atrelada",
		"monitorada",
		"agravada",
		"raptada",
		"penalizada",
		"apurada",
		"queimada",
		"pintada",
		"entrevistada",
		"adiantada",
		"fazer cada",
		"ordenada",
		"sepultada",
		"inventada",
		"dispensada",
		"esgotada",
		"arrancada",
		"firmada",
		"apelidada",
		"sustentada",
		"chocada",
		"faz piada",
		"terá entrada",
		"exonerada",
		"ratida",
		"retratada",
		"protagonizada",
		"torturada",
		"assolapada",
		"abalada",
		"plantada",
		"centrada",
		"manifestada",
		"generalizada",
		"dar risada",
		"desesperada",
		"enquadrada",
		"culpada",
		"enfrentada",
		"efetivada",
		"alagada",
		"ambientada",
		"complementada",
		"espalhada",
		"piada",
		"frustrada",
		"sejam cada",
		"compensada",
		"valorizada",
		"descarregada",
		"examinada",
		"assinalada",
		"consolidada",
		"tocada",
		"notada",
		"trancada",
		"carregada",
		"privada",
		"pesada",
		"travada",
		"rebaixada",
		"restaurada",
		"arrematada",
		"intensida",
		"interceptada",
		"revoltada",
		"assustada",
		"r marcada",
		"crescer cada",
		"equacionada",
		"confrontada",
		"recheada",
		"irritada",
		"deputada",
		"animada",
		"calada",
		"cotada",
		"encantada",
		"ponderada",
		"desvendada",
		"remarcada",
		"armazenada",
		"assediada",
		"depositada",
		"vem equipada",
		"sorteada",
		"encenada",
		"ajustada",
		"impressionada",
		"regulada",
		"perguntada",
		"desviada",
		"amarrada",
		"leiloada",
		"revisada",
		"sagrada",
		"fabricada",
		"empregada",
		"m cada",
		"estipulada",
		"investido cada",
		"mandada",
		"adicionada",
		"enganada",
		"equivocada",
		"empurrada",
		"aconselhada",
		"armada",
		"demonstrada",
		"ativada",
		"arbitrada",
		"exportada",
		"separada",
		"validada",
		"pautada",
		"privatizada",
		"rá marcada",
		"desclassida",
		"cassada",
		"agraciada",
		"viabilizada",
		"ver cada",
		"guardada",
		"anexada",
		"estrangulada",
		"redobrada",
		"repensada",
		"denominada",
		"estimulada",
		"baixada",
		"dando risada",
		"emocionada",
		"faz cada",
		"comer nada",
		"cogitada",
		"reivindicada",
		"desligada",
		"avistada",
		"replicada",
		"arrasada",
		"suportada",
		"picada",
		"importada",
		"tombada",
		"mobilizada",
		"narrada",
		"namorada",
		"curada",
		"desmantelada",
		"contatada",
		"recepcionada",
		"indignada",
		"equilibrada",
		"saudada",
		"contraindicada",
		"interrogada",
		"amada",
		"confiada",
		"reportada",
		"efectuada",
		"vazada",
		"pressionada",
		"conectada",
		"graduada",
		"cultivada",
		"articulada",
		"vira piada",
		"filiada",
		"censurada",
		"mergulhada",
		"aliada",
		"subordinada",
		"congelada",
		"governada",
		"devastada",
		"desarticulada",
		"acendida",
		"golpeada",
		"reprovada",
		"estagnada",
		"regularizada",
		"prestigiada",
		"ovacionada",
		"variada",
		"amparada",
		"infundada",
		"corroborada",
		"diferenciada",
		"poupada",
		"saqueada",
		"vandalizada",
		"chateada",
		"molhada",
		"contaminada",
		"frequentada",
		"desafiada",
		"embargada",
		"morre afogada",
		"exagerada",
		"mulada",
		"patrocinada",
		"treinada",
		"apostada",
		"investir cada",
		"cresce cada",
		"presenciada",
		"alojada",
		"do cada",
		"inadequada",
		"dourada",
		"cuidada",
		"impetrada",
		"estarrelacionada",
		"reajustada",
		"ofertada",
		"acrescentada",
		"cantada",
		"deu risada",
		"ocasionada",
		"galardoada",
		"prolongada",
		"aperfeiçoada",
		"licitada",
		"atirada",
		"infectada",
		"engraçada",
		"empossada",
		"consumada",
		"inundada",
		"quitada",
		"facilitada",
		"empolgada",
		"embriagada",
		"completada",
		"rechaçada",
		"contabilizada",
		"bombardeada",
		"detonada",
		"incentivada",
		"imputada",
		"enraizada",
		"estrelada",
		"provada",
		"manipulada",
		"falada",
		"viciada",
		"consagrada",
		"abortada",
		"alugada",
		"intrigada",
		"sentenciada",
		"reavaliada",
		"vaiada",
		"farnada",
		"derivada",
		"dotada",
		"condecorada",
		"ternada",
		"remulada",
		"terminada",
		"estabilizada",
		"desacordada",
		"arriscada",
		"indenizada",
		"habitada",
		"proclamada",
		"mudarnada",
		"abraçada",
		"rodeada",
		"posicionada",
		"apropriada",
		"solucionada",
		"estruturada",
		"décadas",
		"realizadas",
		"relacionadas",
		"tomadas",
		"estradas",
		"armadas",
		"apresentadas",
		"privadas",
		"ligadas",
		"chamadas",
		"usadas",
		"divulgadas",
		"encontradas",
		"temporadas",
		"polegadas",
		"aplicadas",
		"consideradas",
		"entradas",
		"registradas",
		"criadas",
		"utilizadas",
		"afetadas",
		"jornadas",
		"publicadas",
		"dadas",
		"fechadas",
		"determinadas",
		"controladas",
		"levadas",
		"destinadas",
		"jogadas",
		"aprovadas",
		"enviadas",
		"paradas",
		"rodadas",
		"colocadas",
		"identificadas",
		"associadas",
		"bancadas",
		"instaladas",
		"adotadas",
		"veiculadas",
		"voltadas",
		"retiradas",
		"elevadas",
		"marcadas",
		"pancadas",
		"olimpíadas",
		"registadas",
		"localizadas",
		"camadas",
		"diferenciadas",
		"encaminhadas",
		"espalhadas",
		"adequadas",
		"interessadas",
		"variadas",
		"partilhadas",
		"passadas",
		"anunciadas",
		"confirmadas",
		"organizadas",
		"investigadas",
		"analisadas",
		"especializadas",
		"citadas",
		"toleradas",
		"acompanhadas",
		"facadas",
		"avançadas",
		"calçadas",
		"disponibilizadas",
		"lançadas",
		"autorizadas",
		"rajadas",
		"causadas",
		"piadas",
		"disputadas",
		"baseadas",
		"apontadas",
		"avaliadas",
		"antecipadas",
		"isoladas",
		"lâmpadas",
		"pesadas",
		"escadas",
		"ocupadas",
		"queimadas",
		"integradas",
		"obrigadas",
		"arquibancadas",
		"guardadas",
		"preparadas",
		"iniciadas",
		"selecionadas",
		"apuradas",
		"separadas",
		"gravadas",
		"efetuadas",
		"limitadas",
		"esperadas",
		"executadas",
		"beneficiadas",
		"tratadas",
		"pesquisadas",
		"informadas",
		"implementadas",
		"programadas",
		"reveladas",
		"provocadas",
		"tiradas",
		"contratadas",
		"repassadas",
		"ofertadas",
		"retomadas",
		"coletadas",
		"liberadas",
		"erradas",
		"convidadas",
		"premiadas",
		"dedicadas",
		"classificadas",
		"levantadas",
		"ameaçadas",
		"roubadas",
		"comentadas",
		"cotadas",
		"direcionadas",
		"deixadas",
		"formadas",
		"caminhadas",
		"encerradas",
		"acusadas",
		"agendadas",
		"cobradas",
		"praticadas",
		"reservadas",
		"cadastradas",
		"alegadas",
		"indicadas",
		"geradas",
		"trocadas",
		"prestadas",
		"apoiadas",
		"assassinadas",
		"cortadas",
		"observadas",
		"contempladas",
		"chegadas",
		"compartilhadas",
		"fadas",
		"complicadas",
		"negociadas",
		"procuradas",
		"trovoadas",
		"abandonadas",
		"solicitadas",
		"internadas",
		"representadas",
		"captadas",
		"empregadas",
		"danificadas",
		"compradas",
		"pousadas",
		"detalhadas",
		"comercializadas",
		"paralisadas",
		"visitadas",
		"carregadas",
		"elaboradas",
		"inspiradas",
		"bloqueadas",
		"vinculadas",
		"montadas",
		"resgatadas",
		"condenadas",
		"respeitadas",
		"coordenadas",
		"abordadas",
		"convocadas",
		"trabalhadas",
		"pedaladas",
		"interditadas",
		"acionadas",
		"gargalhadas",
		"somadas",
		"armazenadas",
		"embaixadas",
		"ministradas",
		"transportadas",
		"plantadas",
		"alteradas",
		"situadas",
		"atualizadas",
		"preocupadas",
		"granadas",
		"contadas",
		"prejudicadas",
		"vacinadas",
		"atrasadas",
		"quebradas",
		"guiadas",
		"saladas",
		"risadas",
		"concentradas",
		"listadas",
		"canceladas",
		"adaptadas",
		"fachadas",
		"mencionadas",
		"declaradas",
		"focadas",
		"verificadas",
		"aliadas",
		"personalizadas",
		"carenciadas",
		"movimentadas",
		"implantadas",
		"adiadas",
		"público-privadas",
		"infectadas",
		"enfrentadas",
		"julgadas",
		"comprovadas",
		"moderadas",
		"assinadas",
		"forçadas",
		"pintadas",
		"influenciadas",
		"alcançadas",
		"recuperadas",
		"orientadas",
		"baladas",
		"desalojadas",
		"picadas",
		"contabilizadas",
		"destacadas",
		"equipadas",
		"estudadas",
		"exploradas",
		"consultadas",
		"detetadas",
		"qualificadas",
		"financiadas",
		"estruturadas",
		"rejeitadas",
		"congeladas",
		"privilegiadas",
		"afectadas",
		"acumuladas",
		"cruzadas",
		"alagadas",
		"cantadas",
		"votadas",
		"fabricadas",
		"animadas",
		"entrevistadas",
		"detectadas",
		"denunciadas",
		"deslocadas",
		"afastadas",
		"mostradas",
		"transformadas",
		"inesperadas",
		"recomendadas",
		"motivadas",
		"consolidadas",
		"reforçadas",
		"degradadas",
		"comparadas",
		"importadas",
		"pensadas",
		"tocadas",
		"monitoradas",
		"doadas",
		"fixadas",
		"lotadas",
		"pauladas",
		"touradas",
		"conectadas",
		"camaradas",
		"sofisticadas",
		"combinadas",
		"eliminadas",
		"conquistadas",
		"desenhadas",
		"administradas",
		"autoestradas",
		"interpretadas",
		"brigadas",
		"inauguradas",
		"projetadas",
		"desabrigadas",
		"viradas",
		"ousadas",
		"empreitadas",
		"furtadas",
		"testadas",
		"capturadas",
		"lideradas",
		"apagadas",
		"planejadas",
		"contaminadas",
		"atacadas",
		"almofadas",
		"barricadas",
		"esgotadas",
		"apropriadas",
		"postadas",
		"diagnosticadas",
		"inusitadas",
		"credenciadas",
		"filmadas",
		"evitadas",
		"deputadas",
		"notificadas",
		"apertadas",
		"preservadas",
		"delicadas",
		"incorporadas",
		"enterradas",
		"sentadas",
		"operadas",
		"engraçadas",
		"processadas",
		"alinhadas",
		"espadas",
		"efectuadas",
		"equilibradas",
		"sorteadas",
		"estimadas",
		"pegadas",
		"comandadas",
		"terceirizadas",
		"actualizadas",
		"asseguradas",
		"comunicadas",
		"constatadas",
		"infundadas",
		"arrancadas",
		"descartadas",
		"lembradas",
		"baleadas",
		"acordadas",
		"questionadas",
		"namoradas",
		"inadequadas",
		"modificadas",
		"frustradas",
		"equivocadas",
		"evacuadas",
		"barradas",
		"relatadas",
		"centradas",
		"finalizadas",
		"ossadas",
		"demasiadas",
		"amarradas",
		"douradas",
		"valorizadas",
		"sediadas",
		"apreciadas",
		"consagradas",
		"editadas",
		"fiscalizadas",
		"habilitadas",
		"hospitalizadas",
		"apaixonadas",
		"desejadas",
		"dominadas",
		"aguardadas",
		"cultivadas",
		"casadas",
		"madrugadas",
		"andradas",
		"depositadas",
		"derrubadas",
		"ultrapassadas",
		"renovadas",
		"refugiadas",
		"acentuadas",
		"diversificadas",
		"exageradas",
		"mobilizadas",
		"inundadas",
		"desempregadas",
		"vazadas",
		"decretadas",
		"ignoradas",
		"concretizadas",
		"derivadas",
		"denominadas",
		"remuneradas",
		"acertadas",
		"superadas",
		"adicionadas",
		"flagradas",
		"pedradas",
		"imunizadas",
		"melhoradas",
		"recheadas",
		"aproveitadas",
		"enquadradas",
		"desesperadas",
		"inalteradas",
		"improvisadas",
		"certificadas",
		"afiliadas",
		"intensificadas",
		"adiantadas",
		"libertadas",
		"prolongadas",
		"deflagradas",
		"justificadas",
		"condicionadas",
		"licenciadas",
		"salgadas",
		"sinalizadas",
		"exportadas",
		"fundamentadas",
		"conveniadas",
		"prestigiadas",
		"endividadas",
		"reguladas",
		"ajustadas",
		"badaladas",
		"formuladas",
		"generalizadas",
		"advogadas",
		"autuadas",
		"abusadas",
		"violadas",
		"ampliadas",
		"designadas",
		"criticadas",
		"nomeadas",
		"celebradas",
		"posicionadas",
		"acessadas",
		"inacabadas",
		"empenhadas",
		"decoradas",
		"esplanadas",
		"lusíadas",
		"impulsionadas",
		"embaladas",
		"homenageadas",
		"treinadas",
		"lombadas",
		"retratadas",
		"pisadas",
		"arriscadas",
		"alimentadas",
		"traçadas",
		"explicadas",
		"reiteradas",
		"estipuladas",
		"cilindradas",
		"conceituadas",
		"desligadas",
		"desativadas",
		"anuladas",
		"geladas",
		"moradas",
		"ajuizadas",
		"fundadas",
		"iluminadas",
		"pressionadas",
		"contactadas",
		"calculadas",
		"travadas",
		"necessitadas",
		"filiadas",
		"penduradas",
		"confeccionadas",
		"cercadas",
		"interligadas",
		"incentivadas",
		"goleadas",
		"estacionadas",
		"suportadas",
		"habitadas",
		"indesejadas",
		"desempenhadas",
		"matriculadas",
		"reportadas",
		"motorizadas",
		"impactadas",
		"sagradas",
		"indiciadas",
		"misturadas",
		"faladas",
		"alugadas",
		"manipuladas",
		"sequestradas",
		"validadas",
		"penalizadas",
		"atropeladas",
		"arroladas",
		"infetadas",
		"terminadas",
		"multadas",
		"acostumadas",
		"desperdiçadas",
		"atadas",
		"cansadas",
		"ilimitadas",
		"auto-estradas",
		"trapalhadas",
		"articuladas",
		"enxurradas",
		"dotadas",
		"visadas",
		"renomadas",
		"homologadas",
		"subordinadas",
		"falsificadas",
		"arquivadas",
		"saturadas",
		"regulamentadas",
		"injustificadas",
		"efetivadas",
		"reformadas",
		"capacitadas",
		"protagonizadas",
		"fotografadas",
		"soterradas",
		"planeadas",
		"tornadas",
		"elencadas",
		"educadas",
		"desencadeadas",
		"estupradas",
		"falhadas",
		"agravadas",
		"desocupadas",
		"assustadas",
		"assadas",
		"requisitadas",
		"leiloadas",
		"especificadas",
		"açucaradas",
		"arrecadadas",
		"estampadas",
		"assaltadas",
		"agrupadas",
		"estimuladas",
		"caracterizadas",
		"encomendadas",
		"pavimentadas",
		"firmadas",
		"inventadas",
		"largadas",
		"interceptadas",
		"emplacadas",
		"trancadas",
		"aumentadas",
		"achadas",
		"protocoladas",
		"desviadas",
		"abrigadas",
		"arrastadas",
		"ativadas",
		"empatadas",
		"agitadas",
		"prorrogadas",
		"avultadas",
		"torradas",
		"geadas",
		"regularizadas",
		"examinadas",
		"sustentadas",
		"participadas",
		"proporcionadas",
		"orçadas",
		"ensinadas",
		"imputadas",
		"contestadas",
		"amadas",
		"negadas",
		"culpadas",
		"disparadas",
		"anexadas",
		"pautadas",
		"cuidadas",
		"alargadas",
		"adoptadas",
		"custeadas",
		"coladas",
		"lavadas",
		"responsabilizadas",
		"baixadas",
		"reprovadas",
		"licitadas",
		"manifestadas",
		"desencontradas",
		"dispensadas",
		"demarcadas",
		"puxadas",
		"restauradas",
		"derrotadas",
		"pitadas",
		"alojadas",
		"provadas",
		"assinaladas",
		"encaradas",
		"povoadas",
		"molhadas",
		"patrocinadas",
		"familiarizadas",
		"compensadas",
		"catalogadas",
		"rasgadas",
		"confrontadas",
		"atreladas",
		"vistoriadas",
		"privatizadas",
		"referenciadas",
		"quitadas",
		"esburacadas",
		"sanadas",
		"originadas",
		"aprofundadas",
		"demonstradas",
		"embarcadas",
		"enganadas",
		"automatizadas",
		"suscitadas",
		"vedadas",
		"adulteradas",
		"delegadas",
		"habituadas",
		"viciadas",
		"precipitadas",
		"avisadas",
		"despejadas",
		"descontadas",
		"regadas",
		"lesadas",
		"paralimpíadas",
		"atiradas",
		"devastadas",
		"apanhadas",
		"vigiadas",
		"ordenadas",
		"formalizadas",
		"herdadas",
		"legalizadas",
		"documentadas",
		"arrojadas",
		"escaladas",
		"datadas",
		"sacadas",
		"aceleradas",
		"chumbadas",
		"discriminadas",
		"elogiadas",
		"parceladas",
		"conservadas",
		"descentralizadas",
		"reclamadas",
		"revogadas",
		"tripuladas",
		"tributadas",
		"padronizadas",
		"noticiadas",
		"superlotadas",
		"frequentadas",
		"demoradas",
		"marginalizadas",
		"recicladas",
		"ponderadas",
		"negligenciadas",
		"afogadas",
		"acrescentadas",
		"raptadas",
		"engajadas",
		"alertadas",
		"pinceladas",
		"disseminadas",
		"avermelhadas",
		"encarregadas",
		"intercaladas",
		"seleccionadas",
		"torturadas",
		"incendiadas",
		"indignadas",
		"alocadas",
		"asfaltadas",
		"emprestadas",
		"violentadas",
		"veladas",
		"clonadas",
		"auditadas",
		"mapeadas",
		"arcadas",
		"assediadas",
		"compiladas",
		"customizadas",
		"arredondadas",
		"ocasionadas",
		"coronhadas",
		"solucionadas",
		"sancionadas",
		"xadas",
		"preconizadas",
		"ditadas",
		"arremessadas",
		"caçadas",
		"chicotadas",
		"encantadas",
		"desmatadas",
		"deitadas",
		"industrializadas",
		"perpetradas",
		"fragilizadas",
		"encarceradas",
		"supervisionadas",
		"mudadas",
		"ilustradas",
		"abastadas",
		"fracassadas",
		"cobiçadas",
		"afiadas",
		"buscadas",
		"franqueadas",
		"inapropriadas",
		"completadas",
		"notadas",
		"forjadas",
		"confinadas",
		"continuadas",
		"destelhadas",
		"pacificadas",
		"priorizadas",
		"ancoradas",
		"agregadas",
		"vocacionadas",
		"amparadas",
		"acampadas",
		"unificadas",
		"encenadas",
		"noitadas",
		"despachadas",
		"vetadas",
		"mediadas",
		"peladas",
		"recusadas",
		"cotoveladas",
		"subsidiadas",
		"descarregadas",
		"narradas",
		"criptografadas",
		"bofetadas",
		"alternadas",
		"computadas",
		"realojadas",
		"recrutadas",
		"lacradas",
		"alfinetadas",
		"dinamizadas",
		"emocionadas",
		"derrocadas",
		"ajudadas",
		"blindadas",
		"numeradas",
		"invocadas",
		"intencionadas",
		"liquidadas",
		"desatualizadas",
		"vivenciadas",
		"emboscadas",
		"poupadas",
		"hospedadas",
		"encarnadas",
		"acirradas",
		"congestionadas",
		"entrelaçadas",
		"pomadas",
		"juntadas",
		"fragmentadas",
		"anotadas",
		"beiradas",
		"assentadas",
		"ensaiadas",
		"batizadas",
		"temperadas",
		"abaladas",
		"revisadas",
		"rodeadas",
		"ilhadas",
		"arrimadas",
		"revoltadas",
		"curadas",
		"digitalizadas",
		"admiradas",
		"facilitadas",
		"carbonizadas",
		"delimitadas",
		"acatadas",
		"intimadas",
		"arrendadas",
		"reajustadas",
		"endereçadas",
		"pronunciadas",
		"aprimoradas",
		"cabeçadas",
		"traficadas",
		"duplicadas",
		"cristalizadas",
		"enfeitadas",
		"charqueadas",
		"superfaturadas",
		"arrumadas",
		"desmontadas",
		"nómadas",
		"simuladas",
		"reivindicadas",
		"centralizadas",
		"aclamadas",
		"pernadas",
		"fraudadas",
		"dobradas",
		"acabadas",
		"fracionadas",
		"videochamadas",
		"visualizadas",
		"fantasiadas",
		"manchadas",
		"monitorizadas",
		"emanadas",
		"bordadas",
		"rebaixadas",
		"gratificadas",
		"arrombadas",
		"disfarçadas",
		"acaloradas",
		"copiadas",
		"checadas",
		"implicadas",
		"saqueadas",
		"sepultadas",
		"caladas",
		"enraizadas",
		"estadas",
		"confiscadas",
		"civilizadas",
		"valadas",
		"desgastadas",
		"coligadas",
		"afixadas",
		"oficializadas",
		"entusiasmadas",
		"equiparadas",
		"estagnadas",
		"complementadas",
		"evidenciadas",
		"incomodadas",
		"inspecionadas",
		"arborizadas",
		"inflamadas",
		"desbloqueadas",
		"grelhadas",
		"palmadas",
		"rabanadas",
		"inclinadas",
		"individualizadas",
		"apressadas",
		"experimentadas",
		"castigadas",
		"conjugadas",
		"gerenciadas",
		"encriptadas",
		"delineadas",
		"banhadas",
		"replicadas",
		"creditadas",
		"comissionadas",
		"acopladas",
		"reabilitadas",
		"esmagadas",
		"sobrecarregadas",
		"desacompanhadas",
		"joelhadas",
		"ressalvadas",
		"contextualizadas",
		"sincronizadas",
		"tombadas",
		"sitiadas",
		"aconselhadas",
		"demandadas",
		"cunhadas",
		"mandadas",
		"humoradas",
		"pichadas",
		"empadas",
		"camufladas",
		"institucionalizadas",
		"simplificadas",
		"censuradas",
		"empurradas",
		"desafiadas",
		"canalizadas",
		"angariadas",
		"embargadas",
		"enxadas",
		"encostadas",
		"esvaziadas",
		"normalizadas",
		"escravizadas",
		"concessionadas",
		"autenticadas",
		"refinadas",
		"palhaçadas",
		"furadas",
		"vaquejadas",
		"sensibilizadas",
		"amputadas",
		"acomodadas",
		"espancadas",
		"extremadas",
		"malvadas",
		"empanadas",
		"empilhadas",
		"deterioradas",
		"enroladas",
		"direccionadas",
		"estocadas",
		"estragadas",
		"interrogadas",
		"revistadas",
		"quadradas",
		"encaixadas",
		"reparadas",
		"escutadas",
		"toadas",
		"idealizadas",
		"marteladas",
		"tapadas",
		"federadas",
		"desapropriadas",
		"indenizadas",
		"maltratadas",
		"intervencionadas",
		"chocadas",
		"climatizadas",
		"braçadas",
		"rastreadas",
		"abraçadas",
		"confiadas",
		"aposentadas",
		"contrabandeadas",
		"descoladas",
		"pactuadas",
		"tacadas",
		"retrógradas",
		"equacionadas",
		"agarradas",
		"avistadas",
		"encorajadas",
		"pontuadas",
		"moldadas",
		"honradas",
		"empoderadas",
		"erradicadas",
		"enferrujadas",
		"clicadas",
		"adjudicadas",
		"tentadas",
		"silenciadas",
		"depredadas",
		"inchadas",
		"realocadas",
		"viabilizadas",
		"vincadas",
		"espelhadas",
		"carimbadas",
		"cavalgadas",
		"amontoadas",
		"confecionadas",
		"lavradas",
		"reaproveitadas",
		"afinadas",
		"arruadas",
		"alfabetizadas",
		"ex-namoradas",
		"reavaliadas",
		"configuradas",
		"mutiladas",
		"colegiadas",
		"impossibilitadas",
		"imaginadas",
		"bem-humoradas",
		"atravessadas",
		"agraciadas",
		"irritadas",
		"remarcadas",
		"irrigadas",
		"olímpiadas",
		"alçadas",
		"alongadas",
		"promulgadas",
		"assemelhadas",
		"concertadas",
		"averiguadas",
		"espaçadas",
		"desrespeitadas",
		"edificadas",
		"esfaqueadas",
		"obcecadas",
		"vandalizadas",
		"tuteladas",
		"estilizadas",
		"desvalorizadas",
		"enlutadas",
		"instauradas",
		"contatadas",
		"amareladas",
		"descontroladas",
		"consignadas",
		"cassadas",
		"espetadas",
		"machucadas",
		"prateadas",
		"enumeradas",
		"enteadas",
		"desequilibradas",
		"descongeladas",
		"desajustadas",
		"penhoradas",
		"sacrificadas",
		"juradas",
		"otimizadas",
		"uniformizadas",
		"torneadas",
		"sedeadas",
		"orquestradas",
		"recriadas",
		"esfarrapadas",
		"cromadas",
		"acauteladas",
		"onças-pintadas",
		"mascaradas",
		"deletadas",
		"desidratadas",
		"subcontratadas",
		"escancaradas",
		"reutilizadas",
		"providenciadas",
		"traumatizadas",
		"ratificadas",
		"periciadas",
		"estabilizadas",
		"incubadas",
		"desconsideradas",
		"conturbadas",
		"forradas",
		"taxadas",
		"zeradas",
		"urbanizadas",
		"reputadas",
		"debilitadas",
		"deliberadas",
		"apelidadas",
		"sucateadas",
		"amassadas",
		"encabeçadas",
		"enunciadas",
		"desamparadas",
		"acreditadas",
		"projectadas",
		"medicadas",
		"transitadas",
		"mal-intencionadas",
		"intoxicadas",
		"pré-fabricadas",
		"exaltadas",
		"coroadas",
		"vitimadas",
		"transplantadas",
		"chuvadas",
		"aperfeiçoadas",
		"esticadas",
		"indexadas",
		"remanejadas",
		"mesadas",
		"empolgadas",
		"acondicionadas",
		"segregadas",
		"tituladas",
		"aproximadas",
		"encalhadas",
		"encurraladas",
		"embasadas",
		"coreografadas",
		"entoadas",
		"estreladas",
		"propagadas",
		"autografadas",
		"chibatadas",
		"acidentadas",
		"queijadas",
		"escapadas",
		"hasteadas",
		"infestadas",
		"cavadas",
		"arrematadas",
		"impregnadas",
		"salvaguardadas",
		"jangadas",
		"envenenadas",
		"descascadas",
		"renegociadas",
		"intermediadas",
		"impugnadas",
		"geminadas",
		"dubladas",
		"dissipadas",
		"segmentadas",
		"disciplinadas",
		"galardoadas",
		"sobrelotadas",
		"intocadas",
		"recortadas",
		"cogitadas",
		"desadequadas",
		"minimizadas",
		"chefiadas",
		"abarrotadas",
		"desabitadas",
		"gozadas",
		"relegadas",
		"outorgadas",
		"seladas",
		"requalificadas",
		"codificadas",
		"encapuzadas",
		"alienadas",
		"recuadas",
		"freadas",
		"bombardeadas",
		"acarinhadas",
		"metalizadas",
		"mergulhadas",
		"divorciadas",
		"decapitadas",
		"desprezadas",
		"intituladas",
		"humilhadas",
		"materializadas",
		"contratualizadas",
		"alvejadas",
		"abençoadas",
		"arrasadas",
		"despojadas",
		"transacionadas",
		"tipificadas",
		"costuradas",
		"chapadas",
		"ceifadas",
		"alcoolizadas",
		"comemoradas",
		"destiladas",
		"desestruturadas",
		"mecanizadas",
		"ranqueadas",
		"dificultadas",
		"desconectadas",
		"semeadas",
		"pré-selecionadas",
		"pirateadas",
		"perdoadas",
		"ciladas",
		"aliviadas",
		"manadas",
		"incineradas",
		"estressadas",
		"perturbadas",
		"polarizadas",
		"refrigeradas",
		"compromissadas",
		"algemadas",
		"exacerbadas",
		"impetradas",
		"legendadas",
		"modernizadas",
		"aliciadas",
		"consorciadas",
		"saradas",
		"seguradas",
		"estereotipadas",
		"filtradas",
		"olhadas",
		"recarregadas",
		"presenteadas",
		"dizimadas",
		"descontinuadas",
		"governadas",
		"escrutinadas",
		"revitalizadas",
		"pormenorizadas",
		"perfumadas",
		"deportadas",
		"detonadas",
		"domiciliadas",
		"recordadas",
		"tesouradas",
		"relaxadas",
		"rosadas",
		"deturpadas",
		"arranjadas",
		":noticiasrelacionadas",
		"despreparadas",
		"embriagadas",
		"reembolsadas",
		"redobradas",
		"intercetadas",
		"desclassificadas",
		"talhadas",
		"deformadas",
		"encruzilhadas",
		"adoradas",
		"lesionadas",
		"respaldadas",
		"radicadas",
		"marretadas",
		"impressionadas",
		"alicerçadas",
		"assimiladas",
		"emolduradas",
		"inutilizadas",
		"intrincadas",
		"cronometradas",
		"rotuladas",
		"dissimuladas",
		"lança-granadas",
		"goradas",
		"avariadas",
		"caramelizadas",
		"militarizadas",
		"redesenhadas",
		"reiniciadas",
		"lecionadas",
		"desvendadas",
		"comparticipadas",
		"descaracterizadas",
		"embrulhadas",
		"escavadas",
		"requintadas",
		"ninhadas",
		"raspadas",
		"eternizadas",
		"injetadas",
		"engarrafadas",
		"defasadas",
		"tatuadas",
		"graduadas",
		"famigeradas",
		"pulverizadas",
		"comportadas",
		"encetadas",
		"chateadas",
		"ambientadas",
		"antenadas",
		"corroboradas",
		"desacreditadas",
		"remodeladas",
		"pleiteadas",
		"fincadas",
		"podadas",
		"cozinhadas",
		"atenuadas",
		"auxiliadas",
		"envergonhadas",
		"desordenadas",
		"estigmatizadas",
		"sufocadas",
		"ocultadas",
		"desorganizadas",
		"consumadas",
		"decepadas",
		"esbranquiçadas",
		"extraviadas",
		"grudadas",
		"porradas",
		"cravadas",
		"cifradas",
		"borradas",
		"pré-determinadas",
		"politizadas",
		"capitaneadas",
		"decadas",
		"enviesadas",
		"multiplicadas",
		"recompensadas",
		"hackeadas",
		"feijoadas",
		"represadas",
		"ensanguentadas",
		"descontextualizadas",
		"assombradas",
		"legitimadas",
		"musculadas",
		"cavalhadas",
		"desconfiadas",
		"desmanteladas",
		"harmonizadas",
		"magistradas",
		"ozadas",
		"pescadas",
		"disparatadas",
		"enfileiradas",
		"bêbadas",
		"acamadas",
		"abafadas",
		"reformuladas",
		"evocadas",
		"trituradas",
		"intimidadas",
		"recolocadas",
		"balanceadas",
		"carradas",
		"angustiadas",
		"despropositadas",
		"pilotadas",
		"escoltadas",
		"ventiladas",
		"zangadas",
		"sintonizadas",
		"fustigadas",
		"incapacitadas",
		"incrementadas",
		"mescladas",
		"explicitadas",
		"resguardadas",
		"subestimadas",
		"sentenciadas",
		"defraudadas",
		"dentadas",
		"computadorizadas",
		"alavancadas",
		"aparadas",
		"orçamentadas",
		"expressadas",
		"eletrificadas",
		"apetrechadas",
		"guitarradas",
		"nadas",
		"nevadas",
		"incrustadas",
		"dilatadas",
		"clarificadas",
		"decotadas",
		"arruinadas",
		"aventadas",
		"encharcadas",
		"inconformadas",
		"infiltradas",
		"reprogramadas",
		"regionalizadas",
		"reassentadas",
		"meadas",
		"aprisionadas",
		"massacradas",
		"inexploradas",
		"guinadas",
		"patenteadas",
		"supracitadas",
		"desfocadas",
		"desastradas",
		"contrariadas",
		"atestadas",
		"rechaçadas",
		"rachadas",
		"parparticipadas",
		"fraturadas",
		"antiquadas",
		"desmarcadas",
		"higienizadas",
		"humanizadas",
		"molestadas",
		"avantajadas",
		"apostadas",
		"assoalhadas",
		"calcadas",
		"apavoradas",
		"abaixadas",
		"reviradas",
		"paraolimpíadas",
		"potenciadas",
		"digitadas",
		"garrafadas",
		"folgadas",
		"esterilizadas",
		"fadadas",
		"gaseificadas",
		"laminadas",
		"pré-moldadas",
		"recepcionadas",
		"relembradas",
		"desarmadas",
		"derramadas",
		"cursadas",
		"asfixiadas",
		"sub-representadas",
		"caneladas",
		"desqualificadas",
		"pisoteadas",
		"maquiadas",
		"escolarizadas",
		"posadas",
		"ornamentadas",
		"desmembradas",
		"curvadas",
		"aradas",
		"sintetizadas",
		"subutilizadas",
		"acorrentadas",
		"coitadas",
		"portadas",
		"remasterizadas",
		"machadadas",
		"fornadas",
		"quantificadas",
		"popularizadas",
		"desorientadas",
		"apimentadas",
		"amamentadas",
		"destroçadas",
		"grampeadas",
		"transaccionadas",
		"fermentadas",
		"indeterminadas",
		"prensadas",
		"desproporcionadas",
		"cartadas",
		"arraigadas",
		"aterrorizadas",
		"contornadas",
		"criminalizadas",
		"reativadas",
		"gritadas",
		"referendadas",
		"repensadas",
		"custodiadas",
		"descaradas",
		"conflagradas",
		"amenizadas",
		"ressecadas",
		"reagendadas",
		"odiadas",
		"fascinadas",
		"mimadas",
		"universíadas",
		"trajadas",
		"adornadas",
		"assalariadas",
		"caprichadas",
		"correlacionadas",
		"desinformadas",
		"ensolaradas",
		"enfiadas",
		"sonhadas",
		"serradas",
		"tostadas",
		"emperradas",
		"consertadas",
		"colheradas",
		"facultadas",
		"olimpiadas",
		"revisitadas",
		"pedagiadas",
		"inviabilizadas",
		"englobadas",
		"dimensionadas",
		"cerradas",
		"truncadas",
		"suadas",
		"batucadas",
		"cacheadas",
		"amplificadas",
		"mamadas",
		"flechadas",
		"gigatoneladas",
		"perfuradas",
		"potencializadas",
		"reclassificadas",
		"presenciadas",
		"apadrinhadas",
		"descansadas",
		"aglomeradas",
		"bastonadas",
		"rebuscadas",
		"inabilitadas",
		"bem-intencionadas",
		"charadas",
		"desgarradas",
		"empoeiradas",
		"degustadas",
		"consubstanciadas",
		"informatizadas",
		"imobilizadas",
		"publicitadas",
		"roçadas",
		"reencaminhadas",
		"adas",
		"abortadas",
		"sublinhadas",
		"aromatizadas",
		"reestruturadas",
		"pré-instaladas",
		"radicalizadas",
		"pregadas",
		"formatadas",
		"abóbadas",
		"calendarizadas",
		"decepcionadas",
		"enseadas",
		"dissociadas",
		"arrecadas",
		"balançadas",
		"estreadas",
		"exterminadas",
		"estranguladas",
		"replantadas",
		"plasmadas",
		"abonadas",
		"aviadas",
		"atrapalhadas",
		"arregaçadas",
		"boicotadas",
		"flexibilizadas",
		"imortalizadas",
		"exoneradas",
		"minadas",
		"condensadas",
		"convencionadas",
		"envidraçadas",
		"partido",
		"devido",
		"sentido",
		"pedido",
		"conhecido",
		"marido",
		"unido",
		"rápido",
		"recebido",
		"detido",
		"ocorrido",
		"tido",
		"atingido",
		"seguido",
		"desenvolvido",
		"escolhido",
		"proibido",
		"ouvido",
		"válido",
		"perdido",
		"ferido",
		"definido",
		"líquido",
		"vendido",
		"produzido",
		"envolvido",
		"conseguido",
		"vestido",
		"reconhecido",
		"promovido",
		"acontecido",
		"mantido",
		"sofrido",
		"cumprido",
		"nascido",
		"dirigido",
		"reduzido",
		"apreendido",
		"decidido",
		"permitido",
		"garantido",
		"referido",
		"oferecido",
		"estabelecido",
		"cometido",
		"conduzido",
		"exibido",
		"arguido",
		"vencido",
		"transferido",
		"dividido",
		"obtido",
		"ido",
		"concedido",
		"resolvido",
		"havido",
		"tecido",
		"parecido",
		"emitido",
		"surpreendido",
		"submetido",
		"desaparecido",
		"socorrido",
		"discutido",
		"foragido",
		"agredido",
		"adquirido",
		"divertido",
		"impedido",
		"desconhecido",
		"atendido",
		"bandido",
		"vivido",
		"preferido",
		"escondido",
		"lido",
		"assumido",
		"investido",
		"falecido",
		"demitido",
		"apelido",
		"exigido",
		"punido",
		"transmitido",
		"querido",
		"interrompido",
		"servido",
		"protegido",
		"cândido",
		"batido",
		"ex-marido",
		"defendido",
		"esquecido",
		"sucedido",
		"prometido",
		"morrido",
		"comprometido",
		"assistido",
		"cedido",
		"aparecido",
		"recolhido",
		"convencido",
		"crescido",
		"ácido",
		"reunido",
		"indevido",
		"removido",
		"inserido",
		"percebido",
		"sugerido",
		"sólido",
		"trazido",
		"colorido",
		"perseguido",
		"expedido",
		"consumido",
		"entendido",
		"presidido",
		"sabido",
		"fugido",
		"devolvido",
		"movido",
		"rígido",
		"fornecido",
		"surgido",
		"concebido",
		"abatido",
		"gerido",
		"invadido",
		"estendido",
		"híbrido",
		"guido",
		"admitido",
		"corrigido",
		"esclarecido",
		"distinguido",
		"debatido",
		"contido",
		"recém-nascido",
		"absolvido",
		"corrido",
		"bem-sucedido",
		"dióxido",
		"exercido",
		"tímido",
		"subido",
		"traduzido",
		"rendido",
		"acrescido",
		"repetido",
		"temido",
		"preenchido",
		"merecido",
		"compreendido",
		"pretendido",
		"convertido",
		"requerido",
		"aplaudido",
		"respondido",
		"introduzido",
		"ofendido",
		"duvido",
		"medido",
		"agido",
		"arrependido",
		"percorrido",
		"aprendido",
		"despedido",
		"retido",
		"banido",
		"combatido",
		"acolhido",
		"existido",
		"erguido",
		"cozido",
		"comprido",
		"despercebido",
		"revertido",
		"remetido",
		"proferido",
		"recorrido",
		"semiárido",
		"confundido",
		"doido",
		"sobrevivido",
		"comprimido",
		"aquecido",
		"ingerido",
		"concorrido",
		"colhido",
		"decorrido",
		"garrido",
		"falido",
		"induzido",
		"conferido",
		"expandido",
		"úmido",
		"descuido",
		"indefinido",
		"nítido",
		"estúpido",
		"desistido",
		"embutido",
		"agradecido",
		"desiludido",
		"favorecido",
		"difundido",
		"candido",
		"fluido",
		"munido",
		"abastecido",
		"rompido",
		"reagido",
		"reproduzido",
		"desmentido",
		"indeferido",
		"plácido",
		"refletido",
		"advertido",
		"fortalecido",
		"sumido",
		"mentido",
		"restabelecido",
		"reconduzido",
		"demolido",
		"metido",
		"insistido",
		"bebido",
		"absorvido",
		"permanecido",
		"amido",
		"repartido",
		"comido",
		"valido",
		"invertido",
		"descido",
		"enfraquecido",
		"enriquecido",
		"deferido",
		"rescindido",
		"revestido",
		"constrangido",
		"óxido",
		"suspendido",
		"regido",
		"presumido",
		"aborrecido",
		"preterido",
		"aderido",
		"deprimido",
		"monóxido",
		"envelhecido",
		"cuido",
		"dormido",
		"redigido",
		"mal-entendido",
		"resistido",
		"mexido",
		"divido",
		"lúcido",
		"mordido",
		"ressarcido",
		"engolido",
		"adormecido",
		"desprovido",
		"decido",
		"comparecido",
		"dissolvido",
		"correspondido",
		"libido",
		"abrangido",
		"comovido",
		"derretido",
		"precedido",
		"corrompido",
		"podido",
		"convido",
		"florido",
		"omitido",
		"explodido",
		"consentido",
		"fundido",
		"despromovido",
		"resumido",
		"descumprido",
		"ávido",
		"deduzido",
		"atrevido",
		"despido",
		"expelido",
		"desferido",
		"acometido",
		"aguerrido",
		"dolorido",
		"inválido",
		"repreendido",
		"comedido",
		"seduzido",
		"pulido",
		"destemido",
		"auferido",
		"polido",
		"cido",
		"penido",
		"apercebido",
		"descabido",
		"desentendido",
		"distorcido",
		"curtido",
		"cupido",
		"oprimido",
		"procedido",
		"adido",
		"incumbido",
		"ardido",
		"coagido",
		"desprotegido",
		"restringido",
		"hokkaido",
		"húmido",
		"acedido",
		"provido",
		"zumbido",
		"pertencido",
		"despendido",
		"recém-promovido",
		"prendido",
		"inquirido",
		"interferido",
		"pré-aquecido",
		"alarido",
		"extrovertido",
		"antecedido",
		"reprimido",
		"aludido",
		"suprimido",
		"liquido",
		"árido",
		"colidido",
		"enfurecido",
		"chovido",
		"esculpido",
		"surtido",
		"desprevenido",
		"pálido",
		"rapido",
		"excedido",
		"renascido",
		"empreendido",
		"enchido",
		"convivido",
		"prosseguido",
		"entupido",
		"obedecido",
		"repercutido",
		"amadurecido",
		"aferido",
		"prevenido",
		"abolido",
		"espremido",
		"desmedido",
		"tripartido",
		"varrido",
		"encolhido",
		"travestido",
		"transcorrido",
		"aminoácido",
		"saburido",
		"rebatido",
		"contundido",
		"esplêndido",
		"evadido",
		"diferido",
		"renhido",
		"introvertido",
		"combalido",
		"estarrecido",
		"ressentido",
		"cuspido",
		"ingressorapido",
		"torcido",
		"inibido",
		"pré-definido",
		"iludido",
		"sórdido",
		"mórbido",
		"enaltecido",
		"incompreendido",
		"competido",
		"ungido",
		"brígido",
		"ascendido",
		"pré-estabelecido",
		"infringido",
		"entretido",
		"embatido",
		"entristecido",
		"enlouquecido",
		"cabido",
		"preaquecido",
		"compelido",
		"madrido",
		"translúcido",
		"precavido",
		"bólido",
		"ríspido",
		"incorrido",
		"subentendido",
		"rugido",
		"prevalecido",
		"volvido",
		"peróxido",
		"reflectido",
		"empobrecido",
		"sacudido",
		"gélido",
		"digerido",
		"controvertido",
		"límpido",
		"walfrido",
		"vido",
		"revendido",
		"margarido",
		"erigido",
		"fingido",
		"progredido",
		"impávido",
		"tingido",
		"estampido",
		"semi-árido",
		"vertido",
		"endurecido",
		"lava-rápido",
		"reestabelecido",
		"tórrido",
		"quirido",
		"rejuvenescido",
		"extorquido",
		"latido",
		"nutrido",
		"yupido",
		"retorcido",
		"coproduzido",
		"olido",
		"desprendido",
		"embebido",
		"sortido",
		"elegido",
		"desapercebido",
		"arrefecido",
		"prurido",
		"subdesenvolvido",
		"infligido",
		"resido",
		"emagrecido",
		"construido",
		"intrépido",
		"abduzido",
		"[respondido",
		"incluido",
		"exaurido",
		"predefinido",
		"pervertido",
		"saido",
		"desobedecido",
		"enrustido",
		"reinvestido",
		"desinibido",
		"dido",
		"grávido",
		"escurecido",
		"suprido",
		"desnutrido",
		"[partido",
		"repelido",
		"revivido",
		"sucumbido",
		"substituido",
		"tremido",
		"incutido",
		"coibido",
		"persuadido",
		"impelido",
		"coincidido",
		"fétido",
		"hidróxido",
		"implodido",
		"emergido",
		"imprimido",
		"umedecido",
		"guarnecido",
		"peido",
		"multicolorido",
		"reabastecido",
		"fervido",
		"residido",
		"carvalhido",
		"acorrido",
		"enraivecido",
		"extinguido",
		"vívido",
		"rossido",
		"hibrido",
		"gemido",
		"presido",
		"co-produzido",
		"subdividido",
		"tolhido",
		"desimpedido",
		"sorrido",
		"ruido",
		"desfavorecido",
		"flácido",
		"incidido",
		"redefinido",
		"dorido",
		"decrescido",
		"prescindido",
		"zoido",
		"parido",
		"malsucedido",
		"fedido",
		"ilíquido",
		"descomprometido",
		"apodrecido",
		"preestabelecido",
		"readmitido",
		"escorrido",
		"guaido",
		"fido",
		"reconvertido",
		"apetecido",
		"estupido",
		"insípido",
		"atribuido",
		"dispendido",
		"intrometido",
		"rediscutido",
		"premido",
		"braido",
		"bipartido",
		"retransmitido",
		"rido",
		"interagido",
		"amanhecido",
		"adoecido",
		"desassistido",
		"abstido",
		"superaquecido",
		"empedernido",
		"borlido",
		"estremecido",
		"destruido",
		"valfrido",
		"divergido",
		"desfalecido",
		"aikido",
		"distribuido",
		"distendido",
		"urdido",
		"cumplido",
		"irrefletido",
		"reintroduzido",
		"contribuido",
		"shiseido",
		"recém-falecido",
		"pérfido",
		"fodido",
		"insurgido",
		"codirigido",
		"concluido",
		"caido",
		"masellido",
		"placido",
		"remexido",
		"insculpido",
		"submergido",
		"amortecido",
		"bem-recebido",
		"reerguido",
		"persistido",
		"recém-adquirido",
		"incontido",
		"desparecido",
		"encardido",
		"embevecido",
		"dependido",
		"franzido",
		"diminuido",
		"redimido",
		"pedorido",
		"extendido",
		"intercedido",
		"desunido",
		"super-rápido",
		"descolorido",
		"carcomido",
		"mido",
		"aturdido",
		"contorcido",
		"dirimido",
		"nido",
		"regredido",
		"dissuadido",
		"entorpecido",
		"consabido",
		"dúvido",
		"desaquecido",
		"[devido",
		"reinserido",
		"improvido",
		"ex-partido",
		"supreendido",
		"inadvertido",
		"olvido",
		"perecido",
		"demovido",
		"nabonido",
		"ultrarrápido",
		"r?pido",
		"ensandecido",
		"benzido",
		"obscurecido",
		"subvertido",
		"reaparecido",
		"amolecido",
		"arpinido",
		"acido",
		"envaidecido",
		"lambido",
		"cosido",
		"shido",
		"constituido",
		"líbido",
		"kido",
		"lânguido",
		"esquálido",
		"esbatido",
		"sustenido",
		"desguarnecido",
		"desabrido",
		"pressentido",
		"hígido",
		"desabastecido",
		"bushido",
		"imerecido",
		"recém-demitido",
		"remido",
		"nérido",
		"pré-cozido",
		"intervido",
		"exprimido",
		"esbaforido",
		"consistido",
		"afligido",
		"relido",
		"antiácido",
		"coarguido",
		"subnutrido",
		"sonido",
		"mal-sucedido",
		"mantovanido",
		"encarecido",
		"valentinido",
		"gramido",
		"redistribuido",
		"engrandecido",
		"convergido",
		"proíbido",
		"esgrimido",
		"esmorecido",
		"fudido",
		"lagido",
		"namorido",
		"denegrido",
		"desvanecido",
		"turionido",
		"ultra-rápido",
		"lépido",
		"flórido",
		"hapkido",
		"impingido",
		"pendido",
		"reincidido",
		"ressurgido",
		"vida",
		"medida",
		"partida",
		"avenida",
		"seguida",
		"dívida",
		"proibida",
		"corrida",
		"conhecida",
		"almeida",
		"dúvida",
		"torcida",
		"rápida",
		"comida",
		"subida",
		"ida",
		"devida",
		"grávida",
		"bebida",
		"atingida",
		"definida",
		"aparecida",
		"descida",
		"desenvolvida",
		"reduzida",
		"reconhecida",
		"contrapartida",
		"escolhida",
		"promovida",
		"despedida",
		"dirigida",
		"mantida",
		"concedida",
		"produzida",
		"permitida",
		"batida",
		"líquida",
		"recebida",
		"válida",
		"referida",
		"garantida",
		"perdida",
		"dividida",
		"vendida",
		"exibida",
		"ferida",
		"detida",
		"envolvida",
		"flórida",
		"margarida",
		"apreendida",
		"cumprida",
		"convida",
		"cuida",
		"transmitida",
		"ocorrida",
		"conduzida",
		"estabelecida",
		"oferecida",
		"lida",
		"presidida",
		"socorrida",
		"parecida",
		"pedida",
		"divertida",
		"discutida",
		"decidida",
		"indevida",
		"banida",
		"atendida",
		"obtida",
		"nascida",
		"proferida",
		"emitida",
		"ouvida",
		"sólida",
		"escondida",
		"sofrida",
		"resolvida",
		"interrompida",
		"agredida",
		"vivida",
		"defendida",
		"transferida",
		"submetida",
		"movida",
		"florida",
		"desconhecida",
		"comprometida",
		"exigida",
		"adquirida",
		"querida",
		"protegida",
		"desaparecida",
		"assistida",
		"contida",
		"inserida",
		"vencida",
		"suicida",
		"surpreendida",
		"unida",
		"vestida",
		"assumida",
		"investida",
		"prometida",
		"decida",
		"acolhida",
		"impedida",
		"exercida",
		"bem-sucedida",
		"consumida",
		"preferida",
		"duvida",
		"invadida",
		"erguida",
		"recolhida",
		"esquecida",
		"tímida",
		"sentida",
		"sucedida",
		"estendida",
		"conseguida",
		"revertida",
		"servida",
		"trazida",
		"colorida",
		"tida",
		"fornecida",
		"gerida",
		"corrigida",
		"rígida",
		"cometida",
		"acrescida",
		"repetida",
		"convertida",
		"concebida",
		"reunida",
		"preenchida",
		"debatida",
		"requerida",
		"arguida",
		"divida",
		"conferida",
		"cândida",
		"híbrida",
		"cida",
		"sida",
		"consolida",
		"emicida",
		"arrábida",
		"introduzida",
		"expedida",
		"esclarecida",
		"frida",
		"entendida",
		"traduzida",
		"nítida",
		"perseguida",
		"falecida",
		"removida",
		"distinguida",
		"punida",
		"pretendida",
		"ardida",
		"mordida",
		"colhida",
		"antártida",
		"cedida",
		"sobrevida",
		"despercebida",
		"demitida",
		"admitida",
		"homicida",
		"reproduzida",
		"falida",
		"percebida",
		"sugerida",
		"devolvida",
		"convencida",
		"comprida",
		"ofendida",
		"merecida",
		"difundida",
		"restabelecida",
		"recém-nascida",
		"aquecida",
		"compreendida",
		"aplaudida",
		"deferida",
		"indefinida",
		"reprimida",
		"remetida",
		"distorcida",
		"dida",
		"envelhecida",
		"percorrida",
		"cozida",
		"confundida",
		"combatida",
		"refletida",
		"estúpida",
		"inseticida",
		"invertida",
		"rendida",
		"resumida",
		"respondida",
		"temida",
		"adormecida",
		"valida",
		"atlântida",
		"doida",
		"precedida",
		"concorrida",
		"fortalecida",
		"absorvida",
		"constrangida",
		"rebatida",
		"abastecida",
		"ermida",
		"demolida",
		"retida",
		"regida",
		"mexida",
		"desmentida",
		"expandida",
		"revalida",
		"favorecida",
		"desprovida",
		"descabida",
		"agradecida",
		"úmida",
		"abatida",
		"absolvida",
		"foragida",
		"vih/sida",
		"aida",
		"fluida",
		"deprimida",
		"embutida",
		"desmedida",
		"invalida",
		"arrependida",
		"intimida",
		"enfraquecida",
		"presumida",
		"deduzida",
		"lúcida",
		"indeferida",
		"abrangida",
		"herbicida",
		"induzida",
		"renhida",
		"enriquecida",
		"redigida",
		"revestida",
		"guida",
		"surgida",
		"liquida",
		"ácida",
		"ingerida",
		"aguerrida",
		"descumprida",
		"machida",
		"rompida",
		"jazida",
		"mórbida",
		"destemida",
		"dormida",
		"despida",
		"mérida",
		"consentida",
		"comovida",
		"pálida",
		"abolida",
		"repartida",
		"suprimida",
		"aprendida",
		"boavida",
		"aborrecida",
		"bandida",
		"curtida",
		"al-qaida",
		"guarida",
		"apelida",
		"derretida",
		"esculpida",
		"yoshida",
		"hodeida",
		"desprotegida",
		"metida",
		"antecedida",
		"desiludida",
		"hapvida",
		"dissolvida",
		"atrevida",
		"proíbida",
		"saida",
		"inválida",
		"ressarcida",
		"recorrida",
		"engolida",
		"sumida",
		"dolorida",
		"brígida",
		"sacudida",
		"pesticida",
		"empreendida",
		"extrovertida",
		"elucida",
		"pró-vida",
		"aludida",
		"resida",
		"engravida",
		"arida",
		"coagida",
		"reconduzida",
		"munida",
		"aferida",
		"corrompida",
		"ávida",
		"ríspida",
		"acometida",
		"crescida",
		"polida",
		"comedida",
		"suprida",
		"árida",
		"incumbida",
		"restringida",
		"varrida",
		"húmida",
		"prevenida",
		"sórdida",
		"oprimida",
		"amadurecida",
		"combalida",
		"límpida",
		"genocida",
		"élida",
		"eneida",
		"decorrida",
		"preterida",
		"controvertida",
		"tripartida",
		"enfurecida",
		"descuida",
		"seduzida",
		"larvicida",
		"fida",
		"empobrecida",
		"fratricida",
		"auferida",
		"advertida",
		"compadecida",
		"desinibida",
		"obedecida",
		"travestida",
		"provida",
		"esplêndida",
		"correspondida",
		"pegida",
		"fungicida",
		"hiv/sida",
		"bipartida",
		"enlouquecida",
		"diferida",
		"digerida",
		"despromovida",
		"translúcida",
		"estarrecida",
		"flácida",
		"repreendida",
		"estremecida",
		"havida",
		"incida",
		"omitida",
		"candida",
		"cressida",
		"apátrida",
		"reflectida",
		"antárctida",
		"pré-definida",
		"nélida",
		"espremida",
		"expelida",
		"gravida",
		"desprevenida",
		"vertida",
		"desassistida",
		"lleida",
		"coincida",
		"prosseguida",
		"merida",
		"desfavorecida",
		"repercutida",
		"gélida",
		"rodovida",
		"revendida",
		"entupida",
		"fundida",
		"prócida",
		"tremida",
		"reestabelecida",
		"vívida",
		"talidomida",
		"iludida",
		"pré-estabelecida",
		"comprimida",
		"fervida",
		"elida",
		"derrida",
		"fugida",
		"sabida",
		"acedida",
		"retorcida",
		"zuraida",
		"pré-preenchida",
		"nutrida",
		"inibida",
		"ressentida",
		"infligida",
		"enaltecida",
		"kishida",
		"rapida",
		"progrida",
		"malsucedida",
		"explodida",
		"renascida",
		"sachsida",
		"desnutrida",
		"erigida",
		"incompreendida",
		"tecida",
		"inquirida",
		"bífida",
		"urdida",
		"rejuvenescida",
		"bactericida",
		"introvertida",
		"#conexãopelavida",
		"ebtida",
		"inadvertida",
		"revida",
		"desimpedida",
		"militar/cedida",
		"codevida",
		"escurecida",
		"entristecida",
		"exaurida",
		"desapercebida",
		"embebida",
		"agrida",
		"entretida",
		"nereida",
		"acontecida",
		"ishida",
		"irrefletida",
		"poliamida",
		"descomprometida",
		"cheida",
		"lampre-merida",
		"encolhida",
		"incontida",
		"imprimida",
		"procedida",
		"tingida",
		"endurecida",
		"onusida",
		"desferida",
		"desprendida",
		"predefinida",
		"tiida",
		"multicolorida",
		"druida",
		"subdividida",
		"repelida",
		"lambida",
		"rashida",
		"despendida",
		"lérida",
		"hidroclorotiazida",
		"compelida",
		"tolhida",
		"semiárida",
		"bida",
		"preestabelecida",
		"leida",
		"freixo-arrábida",
		"carótida",
		"guarnecida",
		"reintroduzida",
		"coibida",
		"pervertida",
		"revivida",
		"uchida",
		"dirimida",
		"construida",
		"precavida",
		"intrépida",
		"zaida",
		"fingida",
		"giufrida",
		"insecticida",
		"parida",
		"desunida",
		"desfalecida",
		"pérfida",
		"coproduzida",
		"recém-adquirida",
		"apodrecida",
		"ultrarrápida",
		"amortecida",
		"denegrida",
		"vih-sida",
		"farida",
		"remexida",
		"endivida",
		"insípida",
		"incutida",
		"pida",
		"meia-vida",
		"cuspida",
		"hemorroida",
		"rida",
		"arremetida",
		"finasterida",
		"fedida",
		"fuenzalida",
		"hermida",
		"tórrida",
		"semirrígida",
		"subvertida",
		"preconcebida",
		"recém-promovida",
		"desabastecida",
		"desguarnecida",
		"baida",
		"umedecida",
		"fétida",
		"redefinida",
		"raticida",
		"extorquida",
		"ensandecida",
		"ilíquida",
		"pré-concebida",
		"benzida",
		"colida",
		"d?vida",
		"concluida",
		"aderida",
		"retransmitida",
		"splendida",
		"amolecida",
		"carcomida",
		"brida",
		"mal-sucedida",
		"envida",
		"rediscutida",
		"reinvestida",
		"presida",
		"embevecida",
		"impelida",
		"impávida",
		"aleida",
		"rescindida",
		"distribuida",
		"excedida",
		"crisálida",
		"reerguida",
		"subdesenvolvida",
		"desabrida",
		"acrilamida",
		"estupida",
		"lenalidomida",
		"khálida",
		"volvida",
		"reconvertida",
		"cindida",
		"destruida",
		"constituida",
		"brigida",
		"incluida",
		"insculpida",
		"oxida",
		"nishida",
		"convalida",
		"desaquecida",
		"suthida",
		"ressequida",
		"desobedecida",
		"arrefecida",
		"obscurecida",
		"esbatida",
		"enzalutamida",
		"hiv-sida",
		"plácida",
		"lânguida",
		"implodida",
		"furosemida",
		"enraivecida",
		"reabastecida",
		"zida",
		"subentendida",
		"envaidecida",
		"imerecida",
		"pré-cozida",
		"desentendida",
		"civil/cedida",
		"enegrecida",
		"dorida",
		"subnutrida",
		"suspendida",
		"qaida",
		"entorpecida",
		"lollobrigida",
		"bem-resolvida",
		"desparecida",
		"tépida",
		"avida",
		"cara-pálida",
		"adida",
		"franzida",
		"frígida",
		"esquálida",
		"oneida",
		"apparecida",
		"bem-recebida",
		"ungida",
		"superaquecida",
		"khalida",
		"guarda-vida",
		"hibrida",
		"freida",
		"carrapaticida",
		"co-produzida",
		"dalida",
		"atribuida",
		"maida",
		"nida",
		"extendida",
		"atentado-suicida",
		"encardida",
		"marcha-corrida",
		"bombista-suicida",
		"substituida",
		"readmitida",
		"vilaneida",
		"cálida",
		"apalutamida",
		"intrometida",
		"okaida",
		"zoraida",
		"peida",
		"contra-partida",
		"descolorida",
		"clarida",
		"brízida",
		"abduzida",
		"áida",
		"apetecida",
		"persuadida",
		"marida",
		"distendida",
		"resistida",
		"solida",
		"revolvida",
		"ultra-rápida",
		"escorrida",
		"aramida",
		"comvida",
		"erodida",
		"inferida",
		"regicida",
		"reexibida",
		"protevida",
		"neida",
		"moraleida",
		"enchida",
		"enrustida",
		"sortida",
		"unidos",
		"partidos",
		"feridos",
		"pedidos",
		"envolvidos",
		"detidos",
		"conhecidos",
		"produzidos",
		"apreendidos",
		"bandidos",
		"estabelecidos",
		"vendidos",
		"ouvidos",
		"referidos",
		"arguidos",
		"oferecidos",
		"recebidos",
		"sentidos",
		"cometidos",
		"obtidos",
		"atingidos",
		"desenvolvidos",
		"reconhecidos",
		"escolhidos",
		"definidos",
		"seguidos",
		"atendidos",
		"desaparecidos",
		"vestidos",
		"adquiridos",
		"inseridos",
		"divididos",
		"recolhidos",
		"cumpridos",
		"tecidos",
		"rápidos",
		"transferidos",
		"sólidos",
		"reunidos",
		"ocorridos",
		"submetidos",
		"mantidos",
		"concedidos",
		"líquidos",
		"investidos",
		"perdidos",
		"proibidos",
		"válidos",
		"emitidos",
		"desconhecidos",
		"protegidos",
		"exigidos",
		"escondidos",
		"devidos",
		"exibidos",
		"sofridos",
		"surpreendidos",
		"nascidos",
		"conduzidos",
		"impedidos",
		"garantidos",
		"reduzidos",
		"fornecidos",
		"inquiridos",
		"resolvidos",
		"parecidos",
		"queridos",
		"punidos",
		"discutidos",
		"preferidos",
		"foragidos",
		"comprometidos",
		"promovidos",
		"vencidos",
		"comprimidos",
		"assumidos",
		"demitidos",
		"consumidos",
		"abrangidos",
		"coloridos",
		"óbidos",
		"expedidos",
		"recém-nascidos",
		"removidos",
		"permitidos",
		"suprimidos",
		"devolvidos",
		"híbridos",
		"dirigidos",
		"trazidos",
		"transmitidos",
		"esquecidos",
		"servidos",
		"movidos",
		"perseguidos",
		"socorridos",
		"geridos",
		"divertidos",
		"maridos",
		"colhidos",
		"retidos",
		"cedidos",
		"vividos",
		"agredidos",
		"assistidos",
		"abatidos",
		"corrigidos",
		"convencidos",
		"conseguidos",
		"corridos",
		"preenchidos",
		"contidos",
		"admitidos",
		"acolhidos",
		"debatidos",
		"rígidos",
		"redigidos",
		"regidos",
		"embutidos",
		"bem-sucedidos",
		"esclarecidos",
		"tidos",
		"apelidos",
		"acrescidos",
		"indevidos",
		"decididos",
		"sucedidos",
		"ácidos",
		"falecidos",
		"munidos",
		"convertidos",
		"repetidos",
		"interrompidos",
		"lidos",
		"distinguidos",
		"percorridos",
		"enchidos",
		"volvidos",
		"prometidos",
		"fluidos",
		"desfavorecidos",
		"absolvidos",
		"defendidos",
		"introduzidos",
		"ofendidos",
		"remetidos",
		"concebidos",
		"sugeridos",
		"rendidos",
		"abastecidos",
		"banidos",
		"requeridos",
		"favorecidos",
		"entendidos",
		"batidos",
		"idos",
		"traduzidos",
		"conferidos",
		"tímidos",
		"decorridos",
		"concorridos",
		"compreendidos",
		"medidos",
		"percebidos",
		"repartidos",
		"cozidos",
		"despedidos",
		"reproduzidos",
		"aminoácidos",
		"pretendidos",
		"despercebidos",
		"compridos",
		"erguidos",
		"revertidos",
		"absorvidos",
		"ávidos",
		"ressarcidos",
		"invadidos",
		"revestidos",
		"oprimidos",
		"corrompidos",
		"desiludidos",
		"combatidos",
		"confundidos",
		"estendidos",
		"desprotegidos",
		"auferidos",
		"proferidos",
		"aquecidos",
		"úmidos",
		"estúpidos",
		"aplaudidos",
		"distribuidos",
		"desprovidos",
		"respondidos",
		"agradecidos",
		"inválidos",
		"crescidos",
		"ingeridos",
		"aprendidos",
		"reprimidos",
		"temidos",
		"demolidos",
		"falidos",
		"deduzidos",
		"doidos",
		"mal-entendidos",
		"deferidos",
		"exercidos",
		"difundidos",
		"desmentidos",
		"constrangidos",
		"indeferidos",
		"mexidos",
		"metidos",
		"induzidos",
		"arrependidos",
		"surgidos",
		"fortalecidos",
		"revendidos",
		"nítidos",
		"deprimidos",
		"óxidos",
		"acometidos",
		"distorcidos",
		"consentidos",
		"pré-definidos",
		"refletidos",
		"diferidos",
		"advertidos",
		"envelhecidos",
		"coagidos",
		"esculpidos",
		"adormecidos",
		"engolidos",
		"gemidos",
		"rompidos",
		"invertidos",
		"providos",
		"preteridos",
		"desprevenidos",
		"latidos",
		"desferidos",
		"subdesenvolvidos",
		"aborrecidos",
		"comovidos",
		"enfraquecidos",
		"entupidos",
		"travestidos",
		"ardidos",
		"fugidos",
		"comidos",
		"seduzidos",
		"pré-estabelecidos",
		"destemidos",
		"escurecidos",
		"iludidos",
		"floridos",
		"reconduzidos",
		"aferidos",
		"incumbidos",
		"prevenidos",
		"despidos",
		"enriquecidos",
		"despendidos",
		"merecidos",
		"rescindidos",
		"lúcidos",
		"resumidos",
		"indefinidos",
		"empreendidos",
		"rebatidos",
		"omitidos",
		"explodidos",
		"fundidos",
		"entretidos",
		"intrépidos",
		"enlouquecidos",
		"restabelecidos",
		"atrevidos",
		"retorcidos",
		"varridos",
		"despromovidos",
		"incorridos",
		"húmidos",
		"descuidos",
		"precedidos",
		"espremidos",
		"reinvestidos",
		"expandidos",
		"aguerridos",
		"sórdidos",
		"desassistidos",
		"introvertidos",
		"acedidos",
		"desnutridos",
		"dissolvidos",
		"desvalidos",
		"acontecidos",
		"presididos",
		"adidos",
		"enfurecidos",
		"precavidos",
		"infligidos",
		"obedecidos",
		"comedidos",
		"transcorridos",
		"predefinidos",
		"grávidos",
		"estarrecidos",
		"havidos",
		"restringidos",
		"extrovertidos",
		"derretidos",
		"umedecidos",
		"tingidos",
		"inibidos",
		"empobrecidos",
		"áridos",
		"evadidos",
		"ilíquidos",
		"estampidos",
		"preestabelecidos",
		"presumidos",
		"reabastecidos",
		"doloridos",
		"controvertidos",
		"polidos",
		"imunodeprimidos",
		"compelidos",
		"repreendidos",
		"multicoloridos",
		"abolidos",
		"contundidos",
		"digeridos",
		"lípidos",
		"desabastecidos",
		"ressentidos",
		"reintroduzidos",
		"pruridos",
		"mordidos",
		"aludidos",
		"entristecidos",
		"ex-maridos",
		"repelidos",
		"desimpedidos",
		"rugidos",
		"vertidos",
		"descumpridos",
		"impelidos",
		"grunhidos",
		"incompreendidos",
		"readmitidos",
		"descabidos",
		"subdivididos",
		"sumidos",
		"expelidos",
		"avidos",
		"coligidos",
		"embebidos",
		"nutridos",
		"curtidos",
		"eidos",
		"exauridos",
		"extorquidos",
		"remidos",
		"zumbidos",
		"recém-promovidos",
		"impávidos",
		"coarguidos",
		"vívidos",
		"ungidos",
		"mórbidos",
		"correspondidos",
		"sabidos",
		"reinseridos",
		"bólidos",
		"coibidos",
		"pálidos",
		"repercutidos",
		"atribuidos",
		"subnutridos",
		"subidos",
		"amidos",
		"amadurecidos",
		"encolhidos",
		"incluidos",
		"desmedidos",
		"combalidos",
		"sortidos",
		"translúcidos",
		"antiácidos",
		"recorridos",
		"reflectidos",
		"bebidos",
		"torcidos",
		"antecedidos",
		"enaltecidos",
		"desparecidos",
		"alaridos",
		"reconvertidos",
		"pervertidos",
		"renhidos",
		"persuadidos",
		"empedernidos",
		"aduzidos",
		"garridos",
		"descoloridos",
		"ríspidos",
		"revividos",
		"dividos",
		"excedidos",
		"malsucedidos",
		"desapercebidos",
		"desinibidos",
		"supridos",
		"desunidos",
		"insculpidos",
		"flácidos",
		"embevecidos",
		"dispendidos",
		"aderidos",
		"apodrecidos",
		"endurecidos",
		"gélidos",
		"redefinidos",
		"validos",
		"lava-rápidos",
		"tolhidos",
		"esplêndidos",
		"enrustidos",
		"desprendidos",
		"enraivecidos",
		"inadimplidos",
		"franzidos",
		"divergidos",
		"sacudidos",
		"triglicéridos",
		"esgrimidos",
		"prosseguidos",
		"erigidos",
		"substituidos",
		"construidos",
		"abduzidos",
		"guarnecidos",
		"ensandecidos",
		"doridos",
		"dirimidos",
		"límpidos",
		"estupidos",
		"benzidos",
		"tremidos",
		"ultrarrápidos",
		"aturdidos",
		"aidos",
		"fervidos",
		"tórridos",
		"incutidos",
		"péptidos",
		"descomprometidos",
		"entorpecidos",
		"arrefecidos",
		"rapidos",
		"ex-detidos",
		"escorridos",
		"supreendidos",
		"infringidos",
		"peidos",
		"cuspidos",
		"cupidos",
		"premidos",
		"fétidos",
		"tripartidos",
		"renascidos",
		"subentendidos",
		"fingidos",
		"esquálidos",
		"hidróxidos",
		"candidatos/partidos",
		"hibridos",
		"recém-adquiridos",
		"cândidos",
		"encardidos",
		"dissuadidos",
		"desguarnecidos",
		"refugidos",
		"rangidos",
		"pré-medidos",
		"estados-unidos",
		"excluidos",
		"imunossuprimidos",
		"peróxidos",
		"desentendidos",
		"desentupidos",
		"amanhecidos",
		"apetecidos",
		"shidos",
		"cosidos",
		"erodidos",
		"fodidos",
		"fedidos",
		"paridos",
		"destruidos",
		"coproduzidos",
		"co-arguidos",
		"aparecidos",
		"adoecidos",
		"bem-nascidos",
		"intrometidos",
		"expendidos",
		"anti-partidos",
		"androidos",
		"enternecidos",
		"elegidos",
		"evolvidos",
		"imunocomprometidos",
		"insípidos",
		"obidos",
		"pré-preenchidos",
		"rediscutidos",
		"remexidos",
		"tchauqueridos",
		"pérfidos",
		"estalidos",
		"caleidos",
		"bem-recebidos",
		"lânguidos",
		"obscurecidos",
		"superaquecidos",
		"subvertidos",
		"pré-concebidos",
		"bipartidos",
		"contorcidos",
		"reestabelecidos",
		"inadmitidos",
		"rejuvenescidos",
		"ressequidos",
		"fudidos",
		"esbatidos",
		"desatendidos",
		"estadosunidos",
		"liquidos",
		"pré-cozidos",
		"preconcebidos",
		"urdidos",
		"super-rápidos",
		"revolvidos",
		"submergidos",
		"carcomidos",
		"embrutecidos",
		"dormidos",
		"bem-vestidos",
		"antipartidos",
		"afligidos",
		"constituidos",
		"reexibidos",
		"imprimidos",
		"resistidos",
		"inadvertidos",
		"hígidos",
		"distendidos",
		"enegrecidos",
		"autopropelidos",
		"autoinfligidos",
		"carecidos",
		"encarecidos",
		"inqueridos",
		"medidas",
		"dúvidas",
		"partidas",
		"unidas",
		"dívidas",
		"vidas",
		"bebidas",
		"feridas",
		"envolvidas",
		"conhecidas",
		"corridas",
		"oferecidas",
		"ouvidas",
		"apreendidas",
		"vendidas",
		"avenidas",
		"seguidas",
		"desenvolvidas",
		"obtidas",
		"atendidas",
		"detidas",
		"atingidas",
		"definidas",
		"produzidas",
		"rápidas",
		"recebidas",
		"estabelecidas",
		"grávidas",
		"protegidas",
		"desaparecidas",
		"recolhidas",
		"cumpridas",
		"comidas",
		"divididas",
		"devidas",
		"referidas",
		"mantidas",
		"escolhidas",
		"proibidas",
		"fornecidas",
		"reunidas",
		"torcidas",
		"lidas",
		"promovidas",
		"perdidas",
		"emitidas",
		"transmitidas",
		"escondidas",
		"subidas",
		"cometidas",
		"ocorridas",
		"coloridas",
		"desconhecidas",
		"reduzidas",
		"reconhecidas",
		"dirigidas",
		"discutidas",
		"preenchidas",
		"idas",
		"adquiridas",
		"investidas",
		"concedidas",
		"indevidas",
		"parecidas",
		"submetidas",
		"batidas",
		"contidas",
		"curtidas",
		"exigidas",
		"exibidas",
		"colhidas",
		"contrapartidas",
		"conduzidas",
		"dormidas",
		"proferidas",
		"adidas",
		"resolvidas",
		"salva-vidas",
		"repetidas",
		"divertidas",
		"inseridas",
		"válidas",
		"introduzidas",
		"suicidas",
		"rígidas",
		"transferidas",
		"compreendidas",
		"trazidas",
		"sofridas",
		"preferidas",
		"sólidas",
		"garantidas",
		"sentidas",
		"pedidas",
		"líquidas",
		"permitidas",
		"socorridas",
		"vividas",
		"esclarecidas",
		"assumidas",
		"descidas",
		"servidas",
		"interrompidas",
		"abrangidas",
		"nascidas",
		"comprometidas",
		"vencidas",
		"vestidas",
		"pesticidas",
		"reproduzidas",
		"defendidas",
		"esquecidas",
		"tidas",
		"removidas",
		"bem-sucedidas",
		"respondidas",
		"consumidas",
		"decididas",
		"queridas",
		"assistidas",
		"movidas",
		"debatidas",
		"impedidas",
		"prometidas",
		"sugeridas",
		"agredidas",
		"corrigidas",
		"acolhidas",
		"geridas",
		"sucedidas",
		"mexidas",
		"cedidas",
		"invadidas",
		"exercidas",
		"devolvidas",
		"acrescidas",
		"guarda-vidas",
		"conseguidas",
		"convertidas",
		"desfavorecidas",
		"duvidas",
		"punidas",
		"conferidas",
		"despedidas",
		"erguidas",
		"compridas",
		"requeridas",
		"inseticidas",
		"admitidas",
		"mordidas",
		"abastecidas",
		"retidas",
		"concebidas",
		"dividas",
		"difundidas",
		"surpreendidas",
		"abatidas",
		"leônidas",
		"aprendidas",
		"traduzidas",
		"híbridas",
		"favorecidas",
		"jazidas",
		"expedidas",
		"nítidas",
		"ardidas",
		"distinguidas",
		"concorridas",
		"demolidas",
		"entendidas",
		"despercebidas",
		"herbicidas",
		"estendidas",
		"tímidas",
		"midas",
		"combatidas",
		"distorcidas",
		"percebidas",
		"estúpidas",
		"remetidas",
		"perseguidas",
		"arguidas",
		"ácidas",
		"rebatidas",
		"homicidas",
		"inquiridas",
		"revertidas",
		"surgidas",
		"demitidas",
		"cozidas",
		"desprovidas",
		"percorridas",
		"banidas",
		"pretendidas",
		"ofendidas",
		"merecidas",
		"úmidas",
		"revestidas",
		"margaridas",
		"ingeridas",
		"desprotegidas",
		"repartidas",
		"aquecidas",
		"deferidas",
		"absorvidas",
		"esculpidas",
		"suprimidas",
		"húmidas",
		"foragidas",
		"empreendidas",
		"temidas",
		"deduzidas",
		"descabidas",
		"embutidas",
		"reprimidas",
		"induzidas",
		"presididas",
		"regidas",
		"acometidas",
		"refletidas",
		"envelhecidas",
		"convencidas",
		"confundidas",
		"apátridas",
		"rendidas",
		"desmentidas",
		"deprimidas",
		"falidas",
		"falecidas",
		"fungicidas",
		"fluidas",
		"fortalecidas",
		"pré-definidas",
		"floridas",
		"adormecidas",
		"invertidas",
		"áridas",
		"crescidas",
		"decorridas",
		"despidas",
		"recém-nascidas",
		"munidas",
		"indeferidas",
		"pré-estabelecidas",
		"engolidas",
		"precedidas",
		"aplaudidas",
		"entupidas",
		"ressarcidas",
		"fundidas",
		"desnutridas",
		"restabelecidas",
		"resumidas",
		"oprimidas",
		"supridas",
		"constrangidas",
		"descumpridas",
		"rompidas",
		"obedecidas",
		"límpidas",
		"prevenidas",
		"tecidas",
		"consentidas",
		"doidas",
		"travestidas",
		"indefinidas",
		"revendidas",
		"enfraquecidas",
		"hemorroidas",
		"ávidas",
		"auferidas",
		"contramedidas",
		"redigidas",
		"aborrecidas",
		"vertidas",
		"coagidas",
		"expelidas",
		"perseidas",
		"inválidas",
		"tira-dúvidas",
		"abolidas",
		"vívidas",
		"pelópidas",
		"omitidas",
		"atrevidas",
		"pré-concebidas",
		"desassistidas",
		"escurecidas",
		"dissolvidas",
		"multicoloridas",
		"volvidas",
		"havidas",
		"doloridas",
		"gélidas",
		"preestabelecidas",
		"restringidas",
		"preconcebidas",
		"polidas",
		"garridas",
		"ríspidas",
		"incumbidas",
		"superprotegidas",
		"empobrecidas",
		"tremidas",
		"expandidas",
		"genocidas",
		"lúcidas",
		"corrompidas",
		"subnutridas",
		"providas",
		"enriquecidas",
		"predefinidas",
		"renhidas",
		"absolvidas",
		"incorridas",
		"varridas",
		"larvicidas",
		"metidas",
		"aferidas",
		"enlouquecidas",
		"translúcidas",
		"desferidas",
		"preteridas",
		"leonidas",
		"retorcidas",
		"espremidas",
		"lambidas",
		"infligidas",
		"malsucedidas",
		"desmedidas",
		"controvertidas",
		"desiludidas",
		"sórdidas",
		"aguerridas",
		"aludidas",
		"pálidas",
		"tingidas",
		"fratricidas",
		"derretidas",
		"extrovertidas",
		"comprimidas",
		"ermidas",
		"comedidas",
		"correspondidas",
		"dirimidas",
		"digeridas",
		"inibidas",
		"insecticidas",
		"destemidas",
		"estremecidas",
		"druidas",
		"antecedidas",
		"subdivididas",
		"acedidas",
		"amadurecidas",
		"iludidas",
		"repercutidas",
		"nutridas",
		"endurecidas",
		"embebidas",
		"reflectidas",
		"redefinidas",
		"tórridas",
		"seduzidas",
		"explodidas",
		"advertidas",
		"bipartidas",
		"combalidas",
		"acontecidas",
		"agradecidas",
		"prosseguidas",
		"despendidas",
		"setevidas",
		"entretidas",
		"esplêndidas",
		"comovidas",
		"sabidas",
		"reintroduzidas",
		"despromovidas",
		"desprevenidas",
		"exauridas",
		"imunodeprimidas",
		"subdesenvolvidas",
		"sumidas",
		"distribuidas",
		"coibidas",
		"mórbidas",
		"arrependidas",
		"semiáridas",
		"leónidas",
		"introvertidas",
		"reabastecidas",
		"coligidas",
		"fugidas",
		"bactericidas",
		"apodrecidas",
		"enfurecidas",
		"construidas",
		"compelidas",
		"esbatidas",
		"enaltecidas",
		"hemorróidas",
		"incompreendidas",
		"sacudidas",
		"desapercebidas",
		"bandidas",
		"d?vidas",
		"retransmitidas",
		"liquidas",
		"gravidas",
		"saidas",
		"desinibidas",
		"almeidas",
		"desabastecidas",
		"encolhidas",
		"erigidas",
		"incluidas",
		"latrocidas",
		"decidas",
		"fétidas",
		"gemínidas",
		"sortidas",
		"repelidas",
		"pervertidas",
		"raticidas",
		"revividas",
		"desguarnecidas",
		"carótidas",
		"desparecidas",
		"flácidas",
		"guarnecidas",
		"oriónidas",
		"reestabelecidas",
		"enegrecidas",
		"cálidas",
		"excluidas",
		"excedidas",
		"extorquidas",
		"presumidas",
		"paridas",
		"irrefletidas",
		"reinseridas",
		"benzidas",
		"aderidas",
		"estupidas",
		"recorridas",
		"transcorridas",
		"diferidas",
		"destruidas",
		"escorridas",
		"fervidas",
		"bombistas-suicidas",
		"procedidas",
		"reconvertidas",
		"biocidas",
		"encardidas",
		"desimpedidas",
		"urdidas",
		"validas",
		"cuidas",
		"repreendidas",
		"quadrântidas",
		"enchidas",
		"ciberdúvidas",
		"amazônidas",
		"ceramidas",
		"reconduzidas",
		"precavidas",
		"impelidas",
		"imerecidas",
		"parótidas",
		"aquáridas",
		"envidas",
		"fingidas",
		"cosidas",
		"tolhidas",
		"tépidas",
		"descomprometidas",
		"aduzidas",
		"laxmidas",
		"infundidas",
		"reinvestidas",
		"semi-rápidas",
		"subvertidas",
		"incontidas",
		"descoloridas",
		"desobedecidas",
		"carrapaticidas",
		"hibridas",
		"ressentidas",
		"rediscutidas",
		"recém-adquiridas",
		"táuridas",
		"ultrarrápidas",
		"pré-preenchidas",
		"remexidas",
		"infringidas",
		"mal-sucedidas",
		"maldormidas",
		"carcomidas",
		"atribuidas",
		"bem-vestidas",
		"contra-medidas",
		"desprendidas",
		"cuspidas",
		"acendidas",
		"umedecidas",
		"fura-vidas",
		"ilíquidas",
		"insípidas",
		"malnutridas",
		"substituidas",
		"subentendidas",
		"pérfidas",
		"persuadidas",
		"rapidas",
		"sádidas",
		"inadimplidas",
		"lânguidas",
		"hébridas",
		"bastidas",
		"cândidas",
		"ensandecidas",
		"doridas",
		"tripartidas",
		"descurtidas",
		"amolecidas",
		"liberticidas",
		"oriônidas",
		"insculpidas",
		"reerguidas",
		"plácidas",
		"cefeidas",
		"aparecidas",
		"arrefecidas",
		"desatendidas",
		"concluidas",
		"esgrimidas",
		"erodidas",
		"esquálidas",
		"renascidas",
		"incumpridas",
		"incutidas",
		"obscurecidas",
		"líridas",
		"crisálidas",
		"ungidas",
		"arremetidas",
		"estarrecidas",
		"entorpecidas",
		"meias-medidas",
		"não-assistidas",
		"imprimidas",
		"reileonidas",
		"premidas",
		"solidas",
		"implodidas",
	];
}
